!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("apex-chart-react", [], e) : "object" == typeof exports ? exports["apex-chart-react"] = e() : t["apex-chart-react"] = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    function e(n) {
      if (i[n]) return i[n].exports;
      var o = i[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }
    var i = {};
    return e.m = t, e.c = i, e.d = function (t, i, n) {
      e.o(t, i) || Object.defineProperty(t, i, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, e.n = function (t) {
      var i = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(i, "a", i), i;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 7);
  }([function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = i(8),
      u = n(h),
      l = i(1),
      _ = n(l),
      c = i(10),
      d = n(c),
      f = i(13),
      p = n(f),
      g = i(14),
      m = n(g),
      v = i(17),
      y = n(v),
      b = i(18),
      w = n(b),
      x = i(19),
      k = n(x),
      D = i(20),
      C = n(D),
      E = i(3),
      P = n(E),
      M = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return n._configuration = null, n._containerElement = document.createElement("div"), n._containerElement.id = "apex-chart-container", t.append(n._containerElement), n._loadingElement = null, n._noChartDataElement = null, n._controlsElement = null, n._chartsElement = null, n._width = 0, n._height = 0, n._historyData = null, n._orderBookData = null, n._priceHistory = null, n._volumeHistory = null, n._macdHistory = null, n._rangeSelector = null, n._orderBookDepth = null, n._marketPrice = 0, n._loadConfiguration(i), n.setNoChartData(!0), n;
        }
        return a(e, t), s(e, [{
          key: "_loadConfiguration",
          value: function value(t) {
            e.configuration = t, this._configuration = t, this._initialize(), this.dispatchEvent("configurationLoaded");
          }
        }, {
          key: "_initialize",
          value: function value() {
            this._initializeData(), this._build(), this._registerListeners();
          }
        }, {
          key: "_initializeData",
          value: function value() {
            this._historyData = new u.default(), this._orderBookData = new d.default();
          }
        }, {
          key: "_build",
          value: function value() {
            var t = this;
            this._loadingElement = document.createElement("div"), this._loadingElement.classList.add("loading"), this._containerElement.append(this._loadingElement), this._loadingElement.innerText = this._configuration.loading_text, this._noChartDataElement = document.createElement("div"), this._noChartDataElement.classList.add("no-chart-data"), this._containerElement.append(this._noChartDataElement), this._noChartDataElement.innerText = "⦸ No Chart data", this._controlsElement = document.createElement("div"), this._controlsElement.classList.add("controls"), this._containerElement.append(this._controlsElement), this._chartsElement = document.createElement("div"), this._chartsElement.classList.add("charts"), this._containerElement.append(this._chartsElement), this._chartControls = new p.default(this._controlsElement), this._priceHistory = new m.default(this._chartsElement, this._historyData), this._volumeHistory = new y.default(this._chartsElement, this._historyData), this._macdHistory = new w.default(this._chartsElement, this._historyData), this._rangeSelector = new k.default(this._chartsElement, this._historyData), this._orderBookDepth = new C.default(this._chartsElement, this._orderBookData), setTimeout(function () {
              return t._layout();
            }, 100);
          }
        }, {
          key: "_removeChartElement",
          value: function value() {
            this._containerElement.remove(), this._unregisterListeners();
          }
        }, {
          key: "_layout",
          value: function value() {
            this._width = this._containerElement.offsetWidth, this._height = this._containerElement.offsetHeight, this._priceHistory.invalidateDimensions(), this._volumeHistory.invalidateDimensions(), this._macdHistory.invalidateDimensions(), this._rangeSelector.invalidateDimensions(), this._orderBookDepth.invalidateDimensions();
          }
        }, {
          key: "_registerListeners",
          value: function value() {
            var t = this;
            this._onResize = P.default.debounce(this, function () {
              this._width === this._containerElement.offsetWidth && this._height === this._containerElement.offsetHeight || this._layout();
            }, 1e3 / e.configuration.max_fps), window.addEventListener("resize", this._onResize, !0), this._chartControls.addEventListener("stateChanged", function () {
              t._onControlStateChange();
            }), this._priceHistory.addEventListener("indicesChanged", function (e, i) {
              t._volumeHistory.setIndices(e, i), t._macdHistory.setIndices(e, i), t._rangeSelector.setRange(e, i);
            }), this._volumeHistory.addEventListener("indicesChanged", function (e, i) {
              t._priceHistory.setIndices(e, i), t._macdHistory.setIndices(e, i), t._rangeSelector.setRange(e, i);
            }), this._macdHistory.addEventListener("indicesChanged", function (e, i) {
              t._priceHistory.setIndices(e, i), t._volumeHistory.setIndices(e, i), t._rangeSelector.setRange(e, i);
            }), this._rangeSelector.addEventListener("rangeChanged", function (e, i) {
              t._priceHistory.setIndices(e, i), t._volumeHistory.setIndices(e, i), t._macdHistory.setIndices(e, i);
            });
          }
        }, {
          key: "_unregisterListeners",
          value: function value() {
            window.removeEventListener("resize", this._onResize, !0), this._rangeSelector._unregisterListeners(), this._priceHistory._unregisterListeners(), this._volumeHistory._unregisterListeners(), this._macdHistory._unregisterListeners(), this._rangeSelector._unregisterListeners(), this._orderBookDepth._unregisterListeners();
          }
        }, {
          key: "registerAPI",
          value: function value(t) {
            var e = this;
            t.addEventListener("historyDataLoad", function (i) {
              e._chartControls.historyInterval = t.interval, e._historyData.parse(t.interval, i), e.setLoadingState(!1), e.setNoChartData(0 === i.length);
            }), t.addEventListener("loadingStateChanged", function (t) {
              e.setLoadingState(t);
            }), t.addEventListener("historyDataUpdate", function (t) {}), t.addEventListener("orderBookDataLoad", function (t) {
              e._orderBookData.parse(t);
            }), t.addEventListener("orderBookDataUpdate", function (t, i, n) {
              e._orderBookData.add(t, i, n);
            }), t.addEventListener("marketPriceDataUpdate", function (t) {
              e.marketPrice = t;
            });
          }
        }, {
          key: "_onControlStateChange",
          value: function value() {
            this._priceHistory.interval !== this._chartControls.historyInterval && this.dispatchEvent("historyIntervalChange", this._chartControls.historyInterval), this._priceHistory.drawSimpleMovingAverage !== this._chartControls.drawSimpleMovingAverage && (this._priceHistory.drawSimpleMovingAverage = this._chartControls.drawSimpleMovingAverage), this._priceHistory.drawExponentialMovingAverage !== this._chartControls.drawExponentialMovingAverage && (this._priceHistory.drawExponentialMovingAverage = this._chartControls.drawExponentialMovingAverage), this._priceHistory.drawBollingerBands !== this._chartControls.drawBollingerBands && (this._priceHistory.drawBollingerBands = this._chartControls.drawBollingerBands), this._priceHistory.chartType !== this._chartControls.chartType && (this._priceHistory.chartType = this._chartControls.chartType);
          }
        }, {
          key: "setLoadingState",
          value: function value(t) {
            t ? (this._containerElement.style.pointerEvents = "none", this._loadingElement.style.opacity = "1") : (this._containerElement.style.pointerEvents = "", this._loadingElement.style.opacity = "0");
          }
        }, {
          key: "setNoChartData",
          value: function value(t) {
            t ? (this._containerElement.style.pointerEvents = "none", this._noChartDataElement.style.opacity = "1") : (this._containerElement.style.pointerEvents = "", this._noChartDataElement.style.opacity = "0");
          }
        }, {
          key: "configuration",
          get: function get() {
            return this._configuration;
          }
        }, {
          key: "marketPrice",
          get: function get() {
            return this._marketPrice;
          },
          set: function set(t) {
            this._marketPrice = t, this._priceHistory && (this._priceHistory.marketPrice = t), this._orderBookDepth && (this._orderBookDepth.marketPrice = t);
          }
        }]), e;
      }(_.default);
    e.default = M, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      r = function () {
        function t() {
          n(this, t);
        }
        return o(t, [{
          key: "addEventListener",
          value: function value(t, e) {
            this.listeners || (this.listeners = {}), this.listeners[t] = this.listeners[t] || [], this.listeners[t].push(e);
          }
        }, {
          key: "removeEventListener",
          value: function value(t, e) {
            if (this.listeners) {
              var i = this.listeners[t];
              i && i.splice(i.indexOf(e), 1);
            }
          }
        }, {
          key: "dispatchEvent",
          value: function value(t) {
            for (var e = arguments.length, i = Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) i[n - 1] = arguments[n];
            if (this.listeners) {
              var o = this.listeners[t];
              o && o.forEach(function (t) {
                t.apply(null, i);
              });
            }
          }
        }, {
          key: "removeAllEventListeners",
          value: function value(t) {
            t && (this.listeners[t] = []);
          }
        }, {
          key: "removeAllListeners",
          value: function value() {
            this.listeners = {};
          }
        }]), t;
      }();
    e.default = r, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    e.AxisLabelingOrientation = {
      VERTICAL: "1",
      HORIZONTAL: "2"
    }, e.AxisLabelingType = {
      NUMBER: "1",
      CURRENCY: "2",
      DATETIME: "3"
    }, e.ChartType = {
      CANDLESTICK: "1",
      LINE: "2",
      BAR: "3"
    }, e.OrderType = {
      ASK: "1",
      BID: "2"
    }, e.RangeSelectorDragMode = {
      PAN: "1",
      RESIZE_LEFT: "2",
      RESIZE_RIGHT: "3"
    };
  }, function (t, e, i) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      r = i(0),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(r),
      s = function () {
        function t() {
          n(this, t);
        }
        return o(t, null, [{
          key: "drawPath",
          value: function value(t, e, i, n, o) {
            null !== i && (t.fillStyle = i), null !== n && null !== o && (t.lineWidth = o, t.strokeStyle = n), t.beginPath();
            var r = void 0,
              a = void 0,
              s = void 0;
            e.forEach(function (e, i) {
              0 === i ? (r = a = e[0], s = e[1], t.moveTo(e[0], .5 + (0 | e[1]))) : (r = e[0] > r ? e[0] : r, a = e[0] < a ? e[0] : a, s = e[1] > s ? e[1] : s, t.lineTo(e[0], .5 + (0 | e[1])));
            }), null !== n && null !== o && t.stroke(), t.lineTo(r, s), t.lineTo(a, s), null !== i && t.fill();
          }
        }, {
          key: "drawAliasedLine",
          value: function value(t, e, i, n, o, r) {
            var a = Math.abs(o - i),
              s = i < o ? 1 : -1,
              h = -Math.abs(r - n),
              u = n < r ? 1 : -1,
              l = a + h,
              _ = void 0;
            for (t.fillStyle = e; t.fillRect(i, n, 1, 1), i !== o || n !== r;) _ = 2 * l, _ >= h && (l += h, i += s), _ <= a && (l += a, n += u);
          }
        }, {
          key: "debounce",
          value: function value(t, e, i, n) {
            var o;
            return function () {
              var r = t,
                a = arguments,
                s = function s() {
                  o = null, n || e.apply(r, a);
                },
                h = n && !o;
              clearTimeout(o), o = setTimeout(s, i), h && e.apply(r, a);
            };
          }
        }, {
          key: "throttle",
          value: function value(t, e, i) {
            i || (i = 250);
            var n = void 0,
              o = void 0;
            return function () {
              var r = t || this,
                a = Date.now(),
                s = arguments;
              n && a < n + i ? (clearTimeout(o), o = setTimeout(function () {
                n = a, e.apply(r, s);
              }, i)) : (n = a, e.apply(r, s));
            };
          }
        }, {
          key: "abbreviateNumber",
          value: function value(t) {
            var e = Math.log10(t) / 3 | 0;
            if (0 === e) return t;
            var i = a.default.configuration.number_suffixes[e];
            return (0 | t / Math.pow(10, 3 * e)) + i;
          }
        }, {
          key: "formatNumberToLocale",
          value: function value(t, e) {
            var i = a.default.configuration.locale || "en-US",
              n = Math.pow(10, e);
            return isNaN(t) ? "" : 0 === e ? parseInt(t, 10).toLocaleString(i) : (Math.floor(t * n) / n).toLocaleString(i, {
              minimumFractionDigits: e,
              maximumFractionDigits: e
            });
          }
        }, {
          key: "formatUSD",
          value: function value(t, e) {
            var i = "\\d(?=(\\d{3})+" + (e > 0 ? "\\." : "$") + ")";
            return t.toFixed(Math.max(0, ~~e)).replace(new RegExp(i, "g"), "$&,");
          }
        }]), t;
      }();
    e.default = s, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = function t(e, i, n) {
        null === e && (e = Function.prototype);
        var o = Object.getOwnPropertyDescriptor(e, i);
        if (void 0 === o) {
          var r = Object.getPrototypeOf(e);
          return null === r ? void 0 : t(r, i, n);
        }
        if ("value" in o) return o.value;
        var a = o.get;
        if (void 0 !== a) return a.call(n);
      },
      u = i(5),
      l = n(u),
      _ = i(0),
      c = n(_),
      d = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
          return n._data = i, n._itemWidth = 0, n._itemMargin = 0, n._drawStartIndex = Number.MAX_SAFE_INTEGER, n._drawEndIndex = 0, n._dragStartIndex = 0, n._interval = null, n;
        }
        return a(e, t), s(e, [{
          key: "_computeIndices",
          value: function value() {
            var t = this._itemWidth + this._itemMargin,
              e = this._chartDimensions.width / t | 0,
              i = this._drawStartIndex,
              n = 0;
            if (0 !== this._mouseDragXDistance) {
              var o = -(this._mouseDragXDistance / t | 0),
                r = this._data.length - 1 - e;
              i = Math.max(Math.min(this._dragStartIndex + o, r), 0);
            }
            return n = i + e, e > this._data.length && (i = 0, n = this._data.length - 1), n > this._data.length - 1 && (n = this._data.length - 1, i = n - e), (this._drawStartIndex !== i || this._drawEndIndex !== n) && (this._drawStartIndex = i, this._drawEndIndex = n, this.dispatchEvent("indicesChanged", i, n), !0);
          }
        }, {
          key: "_computeBounds",
          value: function value() {}
        }, {
          key: "_registerListeners",
          value: function value() {
            var t = this;
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_registerListeners", this).call(this), this._data.addEventListener("parseComplete", function () {
              t._onParseComplete();
            });
          }
        }, {
          key: "_unregisterListeners",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_unregisterListeners", this).call(this);
          }
        }, {
          key: "_onParseComplete",
          value: function value() {
            this._interval = this._data.interval, this._itemWidth = c.default.configuration.defaults.history_item_width, this._itemMargin = c.default.configuration.defaults.history_item_margin;
            var t = this._chartDimensions.width / (this._itemWidth + this._itemMargin) | 0;
            this._drawEndIndex = this._data.length - 1, this._drawStartIndex = Math.max(this._drawEndIndex - t, 0), this.dispatchEvent("indicesChanged", this._drawStartIndex, this._drawEndIndex), this._draw(!0);
          }
        }, {
          key: "_onMouseLeave",
          value: function value(t) {
            t.target === this._element && h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseLeave", this).call(this, t);
          }
        }, {
          key: "_onMouseDown",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseDown", this).call(this, t), this._dragStartIndex = this._drawStartIndex;
          }
        }, {
          key: "_onMouseUp",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseUp", this).call(this, t), this._draw(!0);
          }
        }, {
          key: "_onMouseMove",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseMove", this).call(this, t), this._mouseIsDown && this._draw(!0);
          }
        }, {
          key: "_onMouseWheel",
          value: function value(t) {
            if (h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseWheel", this).call(this, t), !this._mouseIsDown) {
              var i = this._itemWidth,
                n = this._itemMargin;
              t.deltaY < 0 ? i += .1 * i : i -= .1 * i, i = Math.max(i, .05), n = 0;
              var o = this._itemWidth + this._itemMargin,
                r = i + n,
                a = this._chartDimensions.width / o | 0,
                s = Math.min(this._chartDimensions.width / r | 0, this._data.length),
                u = (this._data.length, (this._mouseX - this._chartDimensions.x) / this._chartDimensions.width),
                l = a - s,
                _ = u * l | 0;
              s > this._data.length && (_ = -this._drawStartIndex), this._drawStartIndex = Math.max(this._drawStartIndex + _, 0), this._itemWidth = i, this._itemMargin = n, this._draw(!0);
            }
          }
        }, {
          key: "setIndices",
          value: function value(t, e) {
            t = Math.max(t, 0), e = Math.min(e, this._data.length - 1);
            var i = e - t,
              n = this._chartDimensions.width / i;
            this._itemWidth === n && 0 === this._itemMargin && this._drawStartIndex === t && this._drawEndIndex === e || (this._itemWidth = n, this._itemMargin = 0, this._drawStartIndex = t, this._drawEndIndex = e, this._draw(!0));
          }
        }, {
          key: "drawStartIndex",
          get: function get() {
            return this._drawStartIndex;
          }
        }, {
          key: "drawEndIndex",
          get: function get() {
            return this._drawEndIndex;
          }
        }, {
          key: "interval",
          get: function get() {
            return this._interval;
          }
        }]), e;
      }(l.default);
    e.default = d, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = i(1),
      u = n(h),
      l = i(0),
      _ = n(l),
      c = i(6),
      d = n(c),
      f = i(15),
      p = n(f),
      g = i(2),
      m = i(3),
      v = n(m),
      y = function (t) {
        function e(t) {
          o(this, e);
          var i = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return i._containerElement = t, i._element = null, i._drawingCanvas = null, i._drawingContext = null, i._renderingCanvas = null, i._renderingContext = null, i._xLabels = null, i._yLabels = null, i._x = 0, i._y = 0, i._width = 0, i._height = 0, i._mouseIsDown = !1, i._mouseDownX = 0, i._mouseDownY = 0, i._mouseUpX = 0, i._mouseUpY = 0, i._mouseDragXDistance = 0, i._mouseDragYDistance = 0, i._currentMouseCursor = "default", i._currentTouchID = null, i._chartDimensions = null, i._xLabelDimensions = null, i._yLabelDimensions = null, i._dimensionsInvalidated = !1, i._elementBoundingRect = null, i._configuration = null, i._pixelRatio = window.devicePixelRatio, i._fontSize = _.default.configuration.defaults.font_size * i._pixelRatio, i._fontFace = _.default.configuration.defaults.font_face, i._font = i._fontSize + "px " + i._fontFace, i._onMouseMove = i._onMouseMove.bind(i), i._onMouseUp = i._onMouseUp.bind(i), i;
        }
        return a(e, t), s(e, [{
          key: "_build",
          value: function value() {
            this._pixelRatio = window.devicePixelRatio, this._fontSize = this._configuration.font_size * this._pixelRatio, this._fontFace = this._configuration.font_face, this._font = this._fontSize + "px " + this._fontFace, this._chartDimensions = new d.default(), this._xLabelDimensions = new d.default(), this._yLabelDimensions = new d.default(), this._element = document.createElement("div"), this._element.classList.add("chart"), this._drawingCanvas = document.createElement("canvas"), this._drawingContext = this._drawingCanvas.getContext("2d", {
              antialias: !1,
              alpha: !1
            }), this._drawingContext.imageSmoothingEnabled = !1, this._drawingContext.imageSmoothingQuality = "low", this._drawingContext.font = this._font, this._renderingCanvas = document.createElement("canvas"), this._renderingContext = this._renderingCanvas.getContext("2d", {
              antialias: !1,
              alpha: !1
            }), this._renderingContext.imageSmoothingEnabled = !1, this._renderingContext.imageSmoothingQuality = "low", this._renderingCanvas.classList.add("chart-canvas"), this._containerElement.append(this._element), this._element.append(this._renderingCanvas), this._elementBoundingRect = this._element.getBoundingClientRect(), this._xLabels = new p.default(), this._xLabels.dimensions = this._xLabelDimensions, this._xLabels.type = g.AxisLabelingType.NUMBER, this._xLabels.orientation = g.AxisLabelingOrientation.HORIZONTAL, this._xLabels.precision = this._configuration.x_label_precision, this._xLabels.font = this._font, this._yLabels = new p.default(), this._yLabels.dimensions = this._yLabelDimensions, this._yLabels.type = g.AxisLabelingType.NUMBER, this._yLabels.orientation = g.AxisLabelingOrientation.VERTICAL, this._yLabels.precision = this._configuration.y_label_precision, this._yLabels.fontFace = this._fontFace, this._yLabels.fontSize = this._fontSize;
          }
        }, {
          key: "invalidateDimensions",
          value: function value() {
            this._computeDimensions();
          }
        }, {
          key: "_computeDimensions",
          value: function value() {
            if (null !== this._configuration) {
              this._dimensionsInvalidated = !1;
              var t = this._element.offsetWidth * this._pixelRatio,
                e = this._element.offsetHeight * this._pixelRatio;
              if (0 !== this._x || 0 !== this._y || this._width !== t || this._height !== e) {
                this._x = 0, this._y = 0, this._width = t, this._height = e, this._drawingCanvas.width = this._width, this._drawingCanvas.height = this._height, this._renderingCanvas.width = this._width, this._renderingCanvas.height = this._height;
                var i = void 0;
                i = this._configuration.x_label_height % 1 == 0 ? this._configuration.x_label_height : this._height * this._configuration.x_label_height;
                var n = void 0;
                n = this._configuration.x_label_height % 1 == 0 ? this._configuration.y_label_width : this._height * this._configuration.y_label_width, this._chartDimensions.x = 0, this._chartDimensions.y = 0, this._chartDimensions.width = this._width - n * this._pixelRatio, this._chartDimensions.height = this._height - i * this._pixelRatio, this._xLabelDimensions.x = 0, this._xLabelDimensions.y = this._height - i * this._pixelRatio, this._xLabelDimensions.width = this._width - n * this._pixelRatio, this._xLabelDimensions.height = i * this._pixelRatio, this._yLabelDimensions.x = this._width - n * this._pixelRatio, this._yLabelDimensions.y = 0, this._yLabelDimensions.width = n * this._pixelRatio, this._yLabelDimensions.height = this._height - i * this._pixelRatio, this._elementBoundingRect = this._element.getBoundingClientRect(), this._dimensionsInvalidated = !0;
              }
            }
          }
        }, {
          key: "_draw",
          value: function value(t) {
            var e = this;
            requestAnimationFrame(function (i) {
              e._drawBackground(t), e._drawLabels(t), e._drawChart(t), e._drawBorders(t), e._render(t), e._dimensionsInvalidated = !1;
            });
          }
        }, {
          key: "_drawBackground",
          value: function value(t) {
            null !== this._configuration && (this._drawingContext.fillStyle = this._configuration.background_color, this._drawingContext.fillRect(0, 0, this._width, this._height));
          }
        }, {
          key: "_drawChart",
          value: function value(t) {}
        }, {
          key: "_drawLabels",
          value: function value(t) {
            this._xLabels.draw(this._drawingContext), this._yLabels.draw(this._drawingContext);
          }
        }, {
          key: "_drawBorders",
          value: function value(t) {}
        }, {
          key: "_render",
          value: function value(t) {
            this._renderingContext.clearRect(0, 0, this._width, this._height), this._drawingCanvas.width && this._drawingCanvas.height && this._renderingContext.drawImage(this._drawingCanvas, 0, 0);
          }
        }, {
          key: "_registerListeners",
          value: function value() {
            var t = this;
            this._element.addEventListener("mouseleave", function (e) {
              return t._onMouseLeave(e);
            }, !0), this._element.addEventListener("mouseenter", function (e) {
              return t._onMouseEnter(e);
            }, !0), window.addEventListener("mousemove", this._onMouseMove, !0), this._element.addEventListener("mousedown", function (e) {
              return t._onMouseDown(e);
            }), window.addEventListener("mouseup", this._onMouseUp), this._element.addEventListener("wheel", v.default.throttle(this, function (t) {
              this._onMouseWheel(t);
            }, _.default.configuration.mouse_wheel_throttle_rate), !0), this._element.addEventListener("touchstart", function (e) {
              return t._onTouchStart(e);
            }), this._element.addEventListener("touchend", function (e) {
              return t._onTouchEnd(e);
            }), this._element.addEventListener("touchcancel", function (e) {
              return t._onTouchCancel(e);
            }), this._element.addEventListener("touchmove", function (e) {
              return t._onTouchMove(e);
            });
          }
        }, {
          key: "_unregisterListeners",
          value: function value() {
            window.removeEventListener("mousemove", this._onMouseMove, !0), window.removeEventListener("mouseup", this._onMouseUp);
          }
        }, {
          key: "_onMouseEnter",
          value: function value(t) {
            void 0 !== t.preventDefault && t.preventDefault();
          }
        }, {
          key: "_onMouseLeave",
          value: function value(t) {
            void 0 !== t.preventDefault && t.preventDefault();
          }
        }, {
          key: "_onMouseMove",
          value: function value(t) {
            void 0 !== t.preventDefault && t.preventDefault(), this._mouseX = t.clientX * this._pixelRatio - this._elementBoundingRect.left * this._pixelRatio, this._mouseY = t.clientY * this._pixelRatio - this._elementBoundingRect.top * this._pixelRatio, this._mouseIsDown && (this._mouseDragXDistance = this._mouseX - this._mouseDownX, this._mouseDragYDistance = this._mouseY - this._mouseDownY);
          }
        }, {
          key: "_onMouseDown",
          value: function value(t) {
            void 0 !== t.preventDefault && t.preventDefault(), this._mouseIsDown = !0, this._mouseDownX = t.clientX * this._pixelRatio - this._elementBoundingRect.left * this._pixelRatio, this._mouseDownY = t.clientY * this._pixelRatio - this._elementBoundingRect.top * this._pixelRatio, this._mouseDragXDistance = 0, this._mouseDragYDistance = 0;
          }
        }, {
          key: "_onMouseUp",
          value: function value(t) {
            void 0 !== t.preventDefault && t.preventDefault(), this._mouseIsDown && (this._mouseIsDown = !1, this._mouseUpX = t.clientX * this._pixelRatio - this._elementBoundingRect.left * this._pixelRatio, this._mouseUpY = t.clientY * this._pixelRatio - this._elementBoundingRect.top * this._pixelRatio), this._mouseDragXDistance = 0, this._mouseDragYDistance = 0;
          }
        }, {
          key: "_onMouseWheel",
          value: function value(t) {
            void 0 !== t.preventDefault && t.preventDefault(), this._onMouseMove(t);
          }
        }, {
          key: "_onTouchStart",
          value: function value(t) {
            if (void 0 !== t.preventDefault && t.preventDefault(), t.changedTouches.length > 0) {
              var e = t.changedTouches[0];
              this._currentTouchID = e.identifier, this._onMouseDown(e);
            }
          }
        }, {
          key: "_onTouchEnd",
          value: function value(t) {
            if (void 0 !== t.preventDefault && t.preventDefault(), t.changedTouches.length > 0) for (var e = 0; e < t.changedTouches.length; e++) {
              var i = t.changedTouches[e];
              if (this._currentTouchID === i.identifier) {
                this._onMouseUp(i), this._currentTouchID = null;
                break;
              }
            }
          }
        }, {
          key: "_onTouchMove",
          value: function value(t) {
            if (void 0 !== t.preventDefault && t.preventDefault(), t.changedTouches.length > 0) for (var e = 0; e < t.changedTouches.length; e++) {
              var i = t.changedTouches[e];
              if (this._currentTouchID === i.identifier) {
                this._onMouseMove(i);
                break;
              }
            }
          }
        }, {
          key: "_onTouchCancel",
          value: function value(t) {
            void 0 !== t.preventDefault && t.preventDefault();
          }
        }, {
          key: "data",
          get: function get() {
            return this._data;
          }
        }, {
          key: "x",
          get: function get() {
            return this._x / this._pixelRatio;
          }
        }, {
          key: "y",
          get: function get() {
            return this._y / this._pixelRatio;
          }
        }, {
          key: "width",
          get: function get() {
            return this._width / this._pixelRatio;
          }
        }, {
          key: "height",
          get: function get() {
            return this._height / this._pixelRatio;
          }
        }, {
          key: "containerElement",
          get: function get() {
            return this._containerElement;
          }
        }]), e;
      }(u.default);
    e.default = y, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      r = function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
          n(this, t), this._x = e, this._y = i, this._width = o, this._height = r;
        }
        return o(t, [{
          key: "setDimensions",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
              n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
            this._x === t && this._y === e && this._width === i && this._height === n || (this._x = t, this._y = e, this._width = i, this._height = n);
          }
        }, {
          key: "x",
          get: function get() {
            return this._x;
          },
          set: function set(t) {
            this._x !== t && (this._x = t);
          }
        }, {
          key: "y",
          get: function get() {
            return this._y;
          },
          set: function set(t) {
            this._y !== t && (this._y = t);
          }
        }, {
          key: "width",
          get: function get() {
            return this._width;
          },
          set: function set(t) {
            this._width !== t && (this._width = t);
          }
        }, {
          key: "height",
          get: function get() {
            return this._height;
          },
          set: function set(t) {
            this._height !== t && (this._height = t);
          }
        }]), t;
      }();
    e.default = r, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      a = i(0),
      s = n(a),
      h = i(21),
      u = n(h),
      l = i(23),
      _ = n(l),
      c = i(24),
      d = n(c),
      f = i(26),
      p = n(f),
      g = i(27),
      m = function () {
        function t(e, i) {
          o(this, t), this.chartContainer = document.getElementById(e), this.config = Object.assign({}, g.DefaultConfig, i);
        }
        return r(t, [{
          key: "DrawChart",
          value: function value() {
            var t = this;
            this.chart = new s.default(this.chartContainer, this.config), this._alphaPointAPI = this.createAlphaPointAPI(), this.chart.registerAPI(this._alphaPointAPI), this._alphaPointAPI.connect(), this.chart.addEventListener("historyIntervalChange", function (e) {
              t.chart.setLoadingState(!0), t._alphaPointAPI.interval = e;
            });
          }
        }, {
          key: "UpdateLevel2Data",
          value: function value(t) {
            this._alphaPointAPI.UpdateLevel2Data(t);
          }
        }, {
          key: "UpdateTickersData",
          value: function value(t) {
            this._alphaPointAPI.UpdateTickersData(t);
          }
        }, {
          key: "OnLoadingStateChange",
          value: function value(t) {
            this._alphaPointAPI.OnLoadingStateChange(t);
          }
        }, {
          key: "UpdateMarketPrice",
          value: function value(t) {
            this._alphaPointAPI.UpdateMarketPrice(t);
          }
        }, {
          key: "DestroyChart",
          value: function value() {
            this.chart && (this._alphaPointAPI.disconnect(), this.chart._removeChartElement());
          }
        }, {
          key: "createAlphaPointAPI",
          value: function value() {
            return this.config.store ? new d.default(this.config.store, this.config.changeTickersInterval) : this.config.chartDataSubject ? new p.default(this.config.chartDataSubject, this.config.changeTickersInterval) : this.config.chartData ? new _.default(this.config.chartData, this.config.changeTickersInterval) : new u.default();
          }
        }]), t;
      }();
    e.default = m, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = i(1),
      u = n(h),
      l = i(0),
      _ = n(l),
      c = i(9),
      d = n(c),
      f = function (t) {
        function e() {
          o(this, e);
          var t = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return t._data = [], t._configuration = _.default.configuration.history_data, t._simpleMovingAverageWindow = t._configuration.simple_moving_average_window, t._exponentialMovingAverageWindow = t._configuration.exponential_moving_average_window, t._macdShortWindow = t._configuration.convergence_divergence_short_window, t._macdLongWindow = t._configuration.convergence_divergence_long_window, t._macdSignalWindow = t._configuration.convergence_divergence_signal_window, t._lowerPriceBound = Number.MAX_SAFE_INTEGER, t._upperPriceBound = 0, t._priceBoundsSpan = 0, t._lowerVolumeBound = Number.MAX_SAFE_INTEGER, t._upperVolumeBound = 0, t._lowerTimeBound = Number.MAX_SAFE_INTEGER, t._upperTimeBound = 0, t._lowerMACDIndicatorBound = Number.MAX_SAFE_INTEGER, t._upperMACDIndicatorBound = 0, t._lowerMACDSignalBound = Number.MAX_SAFE_INTEGER, t._upperMACDSignalBound = 0, t._lowerMACDDisparityBound = Number.MAX_SAFE_INTEGER, t._upperMACDDisparityBound = 0, t._interval = _.default.configuration.defaults.history_interval, t;
        }
        return a(e, t), s(e, [{
          key: "calcMovingAvg",
          value: function value(t, e, i) {
            return i * e + (1 - i) * t;
          }
        }, {
          key: "_append",
          value: function value(t, e, i, n, o, r) {
            var a = void 0,
              s = void 0,
              h = void 0,
              u = void 0,
              l = void 0,
              _ = void 0;
            if (this._data.length > 0 && this._data[this._data.length - 1].timestamp, this._data.length > 0) {
              var c = this._data[this._data.length - 1],
                f = 1 / this._simpleMovingAverageWindow,
                p = 2 / this._exponentialMovingAverageWindow,
                g = 2 / this._macdShortWindow,
                m = 2 / this._macdLongWindow,
                v = 2 / this._macdSignalWindow;
              a = this.calcMovingAvg(c.simpleMovingAverage, i, f), s = this.calcMovingAvg(c.exponentialMovingAverage, i, p), h = this.calcMovingAvg(Math.pow(c.standardDeviation, 2), Math.pow(Math.abs(i - a), 2), f), u = this.calcMovingAvg(c.macdShortAverage, i, g), l = this.calcMovingAvg(c.macdLongAverage, i, m), _ = this.calcMovingAvg(c.macdSignalAverage, u - l, v);
            } else a = i, s = i, h = 0, u = i, l = i, _ = 0;
            var y = new d.default(t, e, i, n, o, r);
            y.simpleMovingAverage = a, y.exponentialMovingAverage = s, y.standardDeviation = Math.sqrt(h), y.macdShortAverage = u, y.macdLongAverage = l, y.macdSignalAverage = _, this._adjustBounds(y), this._data.push(y);
          }
        }, {
          key: "_adjustBounds",
          value: function value(t) {
            t.close < this._lowerPriceBound && (this._lowerPriceBound = t.close), t.close > this._upperPriceBound && (this._upperPriceBound = t.close), this._priceBoundsSpan = this._upperPriceBound - this._lowerPriceBound, t.volume < this._lowerVolumeBound && (this._lowerVolumeBound = t.volume), t.volume > this._upperVolumeBound && (this._upperVolumeBound = t.volume), t.timestamp < this._lowerTimeBound && (this._lowerTimeBound = t.timestamp), t.timestamp > this._upperTimeBound && (this._upperTimeBound = t.timestamp), t.macd < this._lowerMACDIndicatorBound && (this._lowerMACDIndicatorBound = t.macd), t.macd > this._upperMACDIndicatorBound && (this._upperMACDIndicatorBound = t.macd), t.macdSignal < this._lowerMACDSignalBound && (this._lowerMACDSignalBound = t.macdSignal), t.macdSignal > this._upperMACDSignalBound && (this._upperMACDSignalBound = t.macdSignal), t.macdDisparity < this._lowerMACDDisparityBound && (this._lowerMACDDisparityBound = t.macdDisparity), t.macdDisparity > this._upperMACDDisparityBound && (this._upperMACDDisparityBound = t.macdDisparity);
          }
        }, {
          key: "parse",
          value: function value(t, e) {
            var i = this;
            this._lowerPriceBound = Number.MAX_SAFE_INTEGER, this._upperPriceBound = 0, this._priceBoundsSpan = 0, this._lowerVolumeBound = Number.MAX_SAFE_INTEGER, this._upperVolumeBound = 0, this._lowerTimeBound = Number.MAX_SAFE_INTEGER, this._upperTimeBound = 0, this._lowerMACDBound = Number.MAX_SAFE_INTEGER, this._upperMACDBound = 0, this._lowerSignalBound = Number.MAX_SAFE_INTEGER, this._upperSignalBound = 0, this._data = [], this._iterator = 1, this._interval = t, e.forEach(function (t) {
              i._append(t[0], t[1], t[2], t[3], t[4], t[5]);
            }), this.dispatchEvent("parseComplete");
          }
        }, {
          key: "append",
          value: function value(t, e, i, n, o, r) {
            this._append(t, e, i, n, o, r), this.dispatchEvent("appendComplete");
          }
        }, {
          key: "getItemAt",
          value: function value(t) {
            return this._data[t];
          }
        }, {
          key: "hasData",
          get: function get() {
            return this._data.length > 0;
          }
        }, {
          key: "lowerPriceBound",
          get: function get() {
            return this._lowerPriceBound;
          }
        }, {
          key: "upperPriceBound",
          get: function get() {
            return this._upperPriceBound;
          }
        }, {
          key: "priceBoundsSpan",
          get: function get() {
            return this._priceBoundsSpan;
          }
        }, {
          key: "lowerVolumeBound",
          get: function get() {
            return this._lowerVolumeBound;
          }
        }, {
          key: "upperVolumeBound",
          get: function get() {
            return this._upperVolumeBound;
          }
        }, {
          key: "lowerTimeBound",
          get: function get() {
            return this._lowerTimeBound;
          }
        }, {
          key: "upperTimeBound",
          get: function get() {
            return this._upperTimeBound;
          }
        }, {
          key: "lowerMACDIndicatorBound",
          get: function get() {
            return this._lowerMACDIndicatorBound;
          }
        }, {
          key: "upperMACDIndicatorBound",
          get: function get() {
            return this._upperMACDIndicatorBound;
          }
        }, {
          key: "lowerMACDSignalBound",
          get: function get() {
            return this._lowerMACDSignalBound;
          }
        }, {
          key: "upperMACDSignalBound",
          get: function get() {
            return this._upperMACDSignalBound;
          }
        }, {
          key: "interval",
          get: function get() {
            return this._interval;
          }
        }, {
          key: "length",
          get: function get() {
            return this._data.length;
          }
        }]), e;
      }(u.default);
    e.default = f, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      r = function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
            a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
            s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0,
            h = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 0,
            u = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0,
            l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0,
            _ = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0,
            c = arguments.length > 10 && void 0 !== arguments[10] ? arguments[10] : 0,
            d = arguments.length > 11 && void 0 !== arguments[11] ? arguments[11] : 0;
          n(this, t), this._timestamp = e, this._open = i, this._close = o, this._low = a, this._high = r, this._highLowSpan = r - a, this._volume = s, this._bullish = o >= i, this._simpleMovingAverage = h, this._exponentialMovingAverage = u, this._standardDeviation = l, this._macdShortAverage = _, this._macdLongAverage = c, this._macdSignalAverage = d;
        }
        return o(t, [{
          key: "timestamp",
          get: function get() {
            return this._timestamp;
          },
          set: function set(t) {
            this._timestamp = t;
          }
        }, {
          key: "bullish",
          get: function get() {
            return this._bullish;
          }
        }, {
          key: "open",
          get: function get() {
            return this._open;
          },
          set: function set(t) {
            this._open !== t && (this._open = t, this._bullish = this._close >= this._open);
          }
        }, {
          key: "close",
          get: function get() {
            return this._close;
          },
          set: function set(t) {
            this._close !== t && (this._close = t, this._bullish = this._close >= this._open);
          }
        }, {
          key: "high",
          get: function get() {
            return this._high;
          },
          set: function set(t) {
            this._high !== t && (this._high = t, this._highLowSpan = this._high - this._low);
          }
        }, {
          key: "low",
          get: function get() {
            return this._low;
          },
          set: function set(t) {
            this._low !== t && (this._low = t, this._highLowSpan = this._high - this._low);
          }
        }, {
          key: "volume",
          get: function get() {
            return this._volume;
          },
          set: function set(t) {
            this._volume !== t && (this._volume = t);
          }
        }, {
          key: "simpleMovingAverage",
          get: function get() {
            return this._simpleMovingAverage;
          },
          set: function set(t) {
            this._simpleMovingAverage = t;
          }
        }, {
          key: "exponentialMovingAverage",
          get: function get() {
            return this._exponentialMovingAverage;
          },
          set: function set(t) {
            this._exponentialMovingAverage = t;
          }
        }, {
          key: "standardDeviation",
          get: function get() {
            return this._standardDeviation;
          },
          set: function set(t) {
            this._standardDeviation = t;
          }
        }, {
          key: "macdShortAverage",
          get: function get() {
            return this._macdShortAverage;
          },
          set: function set(t) {
            this._macdShortAverage = t;
          }
        }, {
          key: "macdLongAverage",
          get: function get() {
            return this._macdLongAverage;
          },
          set: function set(t) {
            this._macdLongAverage = t;
          }
        }, {
          key: "macdSignalAverage",
          get: function get() {
            return this._macdSignalAverage;
          },
          set: function set(t) {
            this._macdSignalAverage = t;
          }
        }, {
          key: "macdIndicator",
          get: function get() {
            return this._macdShortAverage - this._macdLongAverage;
          }
        }, {
          key: "macdSignal",
          get: function get() {
            return this.macdIndicator - this._macdSignalAverage;
          }
        }, {
          key: "macdDisparity",
          get: function get() {
            return this.macdIndicator - this.macdSignal;
          }
        }]), t;
      }();
    e.default = r, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = i(1),
      u = n(h),
      l = i(11),
      _ = n(l),
      c = function (t) {
        function e() {
          o(this, e);
          var t = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return t._askData = new _.default("ascending"), t._bidData = new _.default("descending"), t._marketPrice = 0, t;
        }
        return a(e, t), s(e, [{
          key: "parse",
          value: function value(t) {
            var e = this;
            t.asks.constructor === Array && t.asks.length > 0 && t.asks.forEach(function (t) {
              e._askData.add(t[0], t[1]);
            }), t.bids.constructor === Array && t.bids.length > 0 && t.bids.forEach(function (t) {
              e._bidData.add(t[0], t[1]);
            }), this.dispatchEvent("parseComplete");
          }
        }, {
          key: "add",
          value: function value(t, e, i) {
            "ask" === t ? this._askData.add(e, i) : "bid" === t && this._bidData.add(e, i), this.dispatchEvent("addComplete");
          }
        }, {
          key: "remove",
          value: function value(t, e, i) {
            "ask" === t ? this._askData.remove(e) : "bid" === t && this._bidData.remove(e), this.dispatchEvent("removeComplete");
          }
        }, {
          key: "getClosestItem",
          value: function value(t, e) {
            return "ask" === t ? this._askData.getClosestItem(e) : "bid" === t ? this._bidData.getClosestItem(e) : null;
          }
        }, {
          key: "hasData",
          get: function get() {
            return this._askData.length > 0 && this._bidData.length > 0;
          }
        }, {
          key: "askData",
          get: function get() {
            return this._askData;
          }
        }, {
          key: "bidData",
          get: function get() {
            return this._bidData;
          }
        }, {
          key: "lowerPriceBound",
          get: function get() {
            return this._bidData.lowerPriceBound;
          }
        }, {
          key: "upperPriceBound",
          get: function get() {
            return this._askData.upperPriceBound;
          }
        }, {
          key: "upperCountBound",
          get: function get() {
            return Math.max(this._askData.upperCountBound, this._bidData.upperCountBound);
          }
        }]), e;
      }(u.default);
    e.default = c, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      r = i(12),
      a = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(r),
      s = function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "ascending";
          n(this, t), this._data = new Map(), this._lowerPriceBound = Number.MAX_SAFE_INTEGER, this._upperPriceBound = 0, this._upperCountBound = 0, this._firstItem = null, this._lastItem = null, this._currentItem = null, this._cumulativeTotalDirection = e;
        }
        return o(t, [{
          key: "_updateItem",
          value: function value(t, e) {
            t.count = e, this._currentItem = t;
          }
        }, {
          key: "_insertItem",
          value: function value(t) {
            for (var e = this._currentItem; e !== t;) {
              if (t.price < e.price) {
                if (null !== e.previous) {
                  if (t.price < e.previous.price) {
                    e = e.previous;
                    continue;
                  }
                  return t.previous = e.previous, t.next = e, e.previous.next = t, e.previous = t, void (this._currentItem = t);
                }
                return e.previous = t, t.next = e, this._firstItem = t, void (this._currentItem = t);
              }
              if (t.price > e.price) {
                if (null !== e.next) {
                  if (t.price > e.next.price) {
                    e = e.next;
                    continue;
                  }
                  return t.previous = e, t.next = e.next, e.next.previous = t, e.next = t, void (this._currentItem = t);
                }
                return e.next = t, t.previous = e, this._lastItem = t, void (this._currentItem = t);
              }
            }
          }
        }, {
          key: "_deleteItem",
          value: function value(t) {
            var e = t.price.toString();
            if (this._data.has(e)) {
              var i = t.previous,
                n = t.next;
              null !== i && null !== n ? (i.next = n, n.previous = i, this._currentItem = i) : null !== n ? (n.previous = null, this._firstItem = n, this._currentItem = n) : null !== i && (i.next = null, this._lastItem = i, this._currentItem = i);
            }
            t.next = null, t.previous = null, this._data.delete(e), 0 === this._data.size ? (this._currentItem = null, this._firstItem = null, this._lastItem = null, this._lowerPriceBound = Number.MAX_SAFE_INTEGER, this._upperPriceBound = 0, this._upperCountBound = 0) : (this._computeCumulatives(), this._computeBounds());
          }
        }, {
          key: "_computeBounds",
          value: function value() {
            this._lowerPriceBound = this._firstItem.price, this._upperPriceBound = this._lastItem.price, this._upperCountBound = "ascending" === this._cumulativeTotalDirection ? this._lastItem.cumulativeCount : this._firstItem.cumulativeCount;
          }
        }, {
          key: "_computeCumulatives",
          value: function value() {
            for (var t = "ascending" === this._cumulativeTotalDirection ? this._firstItem : this._lastItem; null !== t;) {
              var e = "ascending" === this._cumulativeTotalDirection ? t.previous : t.next;
              null !== e ? (t.cumulativeCount = e.cumulativeCount + t.count, t.cumulativeCost = e.cumulativeCost + t.count * t.price) : (t.cumulativeCount = t.count, t.cumulativeCost = t.count * t.price), this._cumulativeTotalDirection, t = "ascending" === this._cumulativeTotalDirection ? t.next : t.previous;
            }
          }
        }, {
          key: "add",
          value: function value(t, e) {
            var i = t.toString();
            if (0 === this._data.size) {
              var n = new a.default(t, e, e);
              this._firstItem = n, this._lastItem = n, this._data.set(i, n), this._currentItem = n;
            } else if (this._data.has(i)) {
              var o = this._data.get(i);
              if (e > 0) {
                if (o.count !== e) {
                  o.count;
                  this._updateItem(o, e);
                }
              } else this._deleteItem(o);
            } else if (e > 0) {
              var r = new a.default(t, e, e);
              this._data.set(i, r), this._insertItem(r);
            }
            this._computeCumulatives(), this._computeBounds();
          }
        }, {
          key: "getClosestItem",
          value: function value(t) {
            if (!this._data.has(t.toString())) {
              if (null !== this._firstItem && this._firstItem.price > t) return this._firstItem;
              if (null !== this._lastItem && this._lastItem.price < t) return this._lastItem;
              for (var e = this._firstItem, i = this._lastItem; null !== e && null !== i;) {
                if (null !== e.next) {
                  if (!(t > e.next.price)) return Math.abs(e.next.price - t) > Math.abs(e.price - t) ? e : e.next;
                  e = e.next;
                } else e = null;
                if (null !== i.previous) {
                  if (!(t < i.previous.price)) return Math.abs(i.previous.price - t) > Math.abs(i.price - t) ? i : i.previous;
                  i = i.previous;
                } else i = null;
              }
              return null;
            }
            this._data.get(t.toString());
          }
        }, {
          key: Symbol.iterator,
          value: function value() {
            var t = this._cumulativeTotalDirection,
              e = "ascending" === t ? this._firstItem : this._lastItem;
            return {
              next: function next() {
                if (null !== e) {
                  var i = {
                    value: e.valueOf(),
                    done: !1
                  };
                  return e = "ascending" === t ? e.next : e.previous, i;
                }
                return {
                  value: void 0,
                  done: !0
                };
              }
            };
          }
        }, {
          key: "length",
          get: function get() {
            return this._data.size;
          }
        }, {
          key: "firstItem",
          get: function get() {
            return this._firstItem;
          }
        }, {
          key: "lastItem",
          get: function get() {
            return this._lastItem;
          }
        }, {
          key: "lowerPriceBound",
          get: function get() {
            return this._lowerPriceBound;
          }
        }, {
          key: "upperPriceBound",
          get: function get() {
            return this._upperPriceBound;
          }
        }, {
          key: "upperCountBound",
          get: function get() {
            return this._upperCountBound;
          }
        }]), t;
      }();
    e.default = s, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      r = function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
          n(this, t), this._previous = null, this._next = null, this._price = e, this._count = i, this._cumulativeCount = o, this._cumulativeCost = r;
        }
        return o(t, [{
          key: "previous",
          get: function get() {
            return this._previous;
          },
          set: function set(t) {
            this._previous = t;
          }
        }, {
          key: "next",
          get: function get() {
            return this._next;
          },
          set: function set(t) {
            this._next = t;
          }
        }, {
          key: "price",
          get: function get() {
            return this._price;
          },
          set: function set(t) {
            this._price = t;
          }
        }, {
          key: "count",
          get: function get() {
            return this._count;
          },
          set: function set(t) {
            this._count = t;
          }
        }, {
          key: "cumulativeCount",
          get: function get() {
            return this._cumulativeCount;
          },
          set: function set(t) {
            this._cumulativeCount = t;
          }
        }, {
          key: "cumulativeCost",
          get: function get() {
            return this._cumulativeCost;
          },
          set: function set(t) {
            this._cumulativeCost = t;
          }
        }]), t;
      }();
    e.default = r, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = i(1),
      u = n(h),
      l = i(0),
      _ = n(l),
      c = function (t) {
        function e(t) {
          o(this, e);
          var i = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return i._containerElement = t, i._timeIntervalGroup = null, i._chartLineGroup = null, i._chartTypeGroup = null, i._timeIntervals = _.default.configuration.time_intervals, i._historyInterval = _.default.configuration.defaults.history_interval, i._drawSimpleMovingAverage = _.default.configuration.defaults.draw_simple_moving_average, i._drawExponentialMovingAverage = _.default.configuration.defaults.draw_exponential_moving_average, i._drawBollingerBands = _.default.configuration.defaults.draw_bollinger_bands, i._chartType = _.default.configuration.defaults.chart_type, i._build(), i._registerListeners(), i._updateState(), i;
        }
        return a(e, t), s(e, [{
          key: "_buildSelectGroup",
          value: function value(t) {
            var e = document.createElement("div");
            e.classList.add("select-group"), this._containerElement.appendChild(e);
            var i = document.createElement("button");
            i.setAttribute("data-group", t), e.appendChild(i);
            var n = document.createElement("ul");
            return e.appendChild(n), e;
          }
        }, {
          key: "_buildButtonGroup",
          value: function value(t) {
            var e = document.createElement("div");
            return e.classList.add("button-group"), this._containerElement.appendChild(e), e;
          }
        }, {
          key: "_addItemToSelectGroup",
          value: function value(t, e, i, n) {
            var o = t.getElementsByTagName("ul")[0];
            if (o) {
              var r = document.createElement("li");
              r.setAttribute("data-group", e), r.setAttribute("data-value", i), r.innerHTML = n, o.appendChild(r);
            }
          }
        }, {
          key: "_addItemToButtonGroup",
          value: function value(t, e, i, n) {
            var o = document.createElement("button");
            o.setAttribute("data-group", e), o.setAttribute("data-value", i), o.innerHTML = n, t.appendChild(o);
          }
        }, {
          key: "_build",
          value: function value() {
            var t = this;
            this._timeIntervalGroup = this._buildSelectGroup("time-interval"), this._timeIntervals.forEach(function (e) {
              t._addItemToSelectGroup(t._timeIntervalGroup, "time-interval", e.seconds.toString(), e.label);
            }), this._chartLineGroup = this._buildButtonGroup("chart-line"), this._addItemToButtonGroup(this._chartLineGroup, "chart-line", "sma", "SMA"), this._addItemToButtonGroup(this._chartLineGroup, "chart-line", "ema", "EMA"), this._addItemToButtonGroup(this._chartLineGroup, "chart-line", "bb", "BB"), this._chartTypeGroup = this._buildButtonGroup("chart-type"), this._addItemToButtonGroup(this._chartTypeGroup, "chart-type", "candlestick", "candle"), this._addItemToButtonGroup(this._chartTypeGroup, "chart-type", "line", "line"), this._addItemToButtonGroup(this._chartTypeGroup, "chart-type", "bar", "bar");
          }
        }, {
          key: "_updateState",
          value: function value() {
            var t = this,
              e = this._timeIntervalGroup.getElementsByTagName("button")[0],
              i = this._timeIntervalGroup.getElementsByTagName("ul")[0];
            i.classList.remove("active"), i.childNodes.forEach(function (i) {
              parseInt(i.dataset.value, 10) === t._historyInterval ? (i.classList.add("active"), e.innerHTML = i.innerHTML + "&nbsp;&#9660;") : i.classList.remove("active");
            }), this._chartLineGroup.childNodes.forEach(function (e) {
              "sma" === e.dataset.value ? t._drawSimpleMovingAverage ? e.classList.add("active") : e.classList.remove("active") : "ema" === e.dataset.value ? t._drawExponentialMovingAverage ? e.classList.add("active") : e.classList.remove("active") : "bb" === e.dataset.value && (t._drawBollingerBands ? e.classList.add("active") : e.classList.remove("active"));
            }), this._chartTypeGroup.childNodes.forEach(function (e) {
              e.dataset.value === t._chartType ? e.classList.add("active") : e.classList.remove("active");
            });
          }
        }, {
          key: "_registerListeners",
          value: function value() {
            var t = this;
            this._containerElement.addEventListener("click", function (e) {
              "BUTTON" === e.target.nodeName ? t._onButtonClick(e) : "LI" === e.target.nodeName && t._onListItemClick(e);
            });
          }
        }, {
          key: "_onTimeIntervalButtonClick",
          value: function value(t) {
            var e = this._timeIntervalGroup.getElementsByTagName("ul")[0];
            e.classList.contains("active") ? e.classList.remove("active") : e.classList.add("active");
          }
        }, {
          key: "_onTimeIntervalListItemClick",
          value: function value(t) {
            var e = parseInt(t.target.dataset.value, 10);
            this.historyInterval !== e && (this.historyInterval = e, this.dispatchEvent("stateChanged"));
          }
        }, {
          key: "_onChartLineButtonClick",
          value: function value(t) {
            "sma" === t.target.dataset.value ? this.drawSimpleMovingAverage = !t.target.classList.contains("active") : "ema" === t.target.dataset.value ? this.drawExponentialMovingAverage = !t.target.classList.contains("active") : "bb" === t.target.dataset.value && (this.drawBollingerBands = !t.target.classList.contains("active")), this.dispatchEvent("stateChanged");
          }
        }, {
          key: "_onChartTypeButtonClick",
          value: function value(t) {
            this.chartType = t.target.dataset.value, this.dispatchEvent("stateChanged");
          }
        }, {
          key: "_onListItemClick",
          value: function value(t) {
            "time-interval" === t.target.dataset.group && this._onTimeIntervalListItemClick(t);
          }
        }, {
          key: "_onButtonClick",
          value: function value(t) {
            "time-interval" === t.target.dataset.group ? this._onTimeIntervalButtonClick(t) : "chart-line" === t.target.dataset.group ? this._onChartLineButtonClick(t) : "chart-type" === t.target.dataset.group && this._onChartTypeButtonClick(t);
          }
        }, {
          key: "containerElement",
          get: function get() {
            return this._containerElement;
          }
        }, {
          key: "historyInterval",
          get: function get() {
            return this._historyInterval;
          },
          set: function set(t) {
            this._historyInterval = t, this._updateState();
          }
        }, {
          key: "drawSimpleMovingAverage",
          get: function get() {
            return this._drawSimpleMovingAverage;
          },
          set: function set(t) {
            this._drawSimpleMovingAverage = t, this._updateState();
          }
        }, {
          key: "drawExponentialMovingAverage",
          get: function get() {
            return this._drawExponentialMovingAverage;
          },
          set: function set(t) {
            this._drawExponentialMovingAverage = t, this._updateState();
          }
        }, {
          key: "drawBollingerBands",
          get: function get() {
            return this._drawBollingerBands;
          },
          set: function set(t) {
            this._drawBollingerBands = t, this._updateState();
          }
        }, {
          key: "chartType",
          get: function get() {
            return this._chartType;
          },
          set: function set(t) {
            this._chartType = t, this._updateState();
          }
        }]), e;
      }(u.default);
    e.default = c, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = function t(e, i, n) {
        null === e && (e = Function.prototype);
        var o = Object.getOwnPropertyDescriptor(e, i);
        if (void 0 === o) {
          var r = Object.getPrototypeOf(e);
          return null === r ? void 0 : t(r, i, n);
        }
        if ("value" in o) return o.value;
        var a = o.get;
        if (void 0 !== a) return a.call(n);
      },
      u = i(4),
      l = n(u),
      _ = i(0),
      c = n(_),
      d = i(6),
      f = n(d),
      p = i(2),
      g = i(3),
      m = n(g),
      v = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, i));
          return n._infoElement = null, n._itemWidth = c.default.configuration.defaults.price_volume_history_item_width, n._itemMargin = 0, n._drawSimpleMovingAverage = c.default.configuration.defaults.draw_simple_moving_average, n._drawExponentialMovingAverage = c.default.configuration.defaults.draw_exponential_moving_average, n._drawBollingerBands = c.default.configuration.defaults.draw_bollinger_bands, n._useGradient = c.default.configuration.price_history.use_gradient, n._useGridLines = c.default.configuration.price_history.use_grid_lines, n._lowerPriceBound = Number.MAX_SAFE_INTEGER, n._upperPriceBound = 0, n._priceBoundsSpan = 0, n._marketPrice = 0, n._chartType = c.default.configuration.defaults.chart_type, n._configuration = Object.assign({}, c.default.configuration.price_history), n._infoDimensions = new f.default(), n._priceChartDimensions = new f.default(), n._build(), n._registerListeners(), n;
        }
        return a(e, t), s(e, [{
          key: "_build",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_build", this).call(this), this._element.classList.add("price-history"), this._infoElement = document.createElement("div"), this._infoElement.classList.add("info"), this._infoLabels = this._configuration.info_labels ? this._configuration.info_labels : ["P", "O", "C", "H", "L", "V"], this._element.append(this._infoElement), this._infoElement.append(document.createElement("span")), this._infoElement.append(document.createElement("span")), this._infoElement.append(document.createElement("span")), this._infoElement.append(document.createElement("span")), this._infoElement.append(document.createElement("span")), this._infoElement.append(document.createElement("span")), this._xLabels.type = p.AxisLabelingType.DATETIME, this._xLabels.fontFace = this._fontFace, this._xLabels.fontSize = this._fontSize, this._xLabels.fontColor = this._configuration.x_label_color, this._yLabels.type = p.AxisLabelingType.CURRENCY, this._yLabels.fontFace = this._fontFace, this._yLabels.fontSize = this._fontSize, this._yLabels.fontColor = this._configuration.y_label_color, this._yLabels.tickPrefix = c.default.configuration.currency_character, this._yLabels.precision = this._configuration.y_label_precision;
          }
        }, {
          key: "_computeDimensions",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_computeDimensions", this).call(this), this._configuration.info_height % 1 == 0 ? this._infoDimensions.height = this._configuration.info_height * this._pixelRatio : this._infoDimensions.height = this._chartDimensions.height * this._configuration.info_height | 0, this._infoDimensions.width = this._chartDimensions.width, this._infoDimensions.x = this._chartDimensions.x, this._infoDimensions.y = this._chartDimensions.y, this._priceChartDimensions.x = this._chartDimensions.x, this._priceChartDimensions.y = this._chartDimensions.y + this._infoDimensions.height, this._priceChartDimensions.width = this._chartDimensions.width, this._priceChartDimensions.height = this._chartDimensions.height - this._infoDimensions.height - 1;
            var t = this._infoElement.style;
            t.top = this._infoDimensions.y / this._pixelRatio + "px", t.left = this._infoDimensions.x / this._pixelRatio + "px", t.width = this._infoDimensions.width / this._pixelRatio + "px", t.height = this._infoDimensions.height / this._pixelRatio + "px", this._yLabelDimensions.y = this._priceChartDimensions.y, this._yLabelDimensions.height = this._priceChartDimensions.height, this._draw();
          }
        }, {
          key: "_computeBounds",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_computeBounds", this).call(this);
            for (var t = Number.MAX_SAFE_INTEGER, i = 0, n = this._drawStartIndex; n < this._drawEndIndex; n++) {
              var o = this._data.getItemAt(n);
              o.low < t && (t = o.low), this._drawSimpleMovingAverage && o.simpleMovingAverage < t && (t = o.simpleMovingAverage.toFixed(6)), this._drawExponentialMovingAverage && o.exponentialMovingAverage < t && (t = o.exponentialMovingAverage), this._drawBollingerBands && Math.max(o.simpleMovingAverage - o.standardDeviation * this._configuration.bollinger_standard_deviation_offset, 0) < t && (t = Math.max(o.simpleMovingAverage - o.standardDeviation * this._configuration.bollinger_standard_deviation_offset, 0)), o.high > i && (i = o.high), this._drawSimpleMovingAverage && o.simpleMovingAverage > i && (i = o.simpleMovingAverage), this._drawExponentialMovingAverage && o.exponentialMovingAverage > i && (i = o.exponentialMovingAverage), this._drawBollingerBands && o.simpleMovingAverage + o.standardDeviation * this._configuration.bollinger_standard_deviation_offset > i && (i = o.simpleMovingAverage + o.standardDeviation * this._configuration.bollinger_standard_deviation_offset);
            }
            return (this._lowerPriceBound !== t || this._upperPriceBound !== i) && (this._lowerPriceBound = t, this._upperPriceBound = i, this._priceBoundsSpan = this._upperPriceBound - this._lowerPriceBound, !0);
          }
        }, {
          key: "_drawCandlestick",
          value: function value(t, e) {
            var i = this._itemWidth / 2 || .5,
              n = this._itemWidth > 1 ? 1 : .5,
              o = n / 2;
            this._drawingContext.fillStyle = t.bullish ? this._configuration.bullish_color : this._configuration.bearish_color;
            var r = Math.max(t.high, t.low),
              a = Math.min(t.high, t.low),
              s = Math.max(t.open, t.close),
              h = Math.min(t.open, t.close),
              u = 1 - (r - this._lowerPriceBound) / this._priceBoundsSpan,
              l = 1 - (a - this._lowerPriceBound) / this._priceBoundsSpan,
              _ = 1 - (s - this._lowerPriceBound) / this._priceBoundsSpan,
              c = 1 - (h - this._lowerPriceBound) / this._priceBoundsSpan,
              d = this._priceChartDimensions.y + u * this._priceChartDimensions.height,
              f = this._priceChartDimensions.y + l * this._priceChartDimensions.height,
              p = this._priceChartDimensions.y + _ * this._priceChartDimensions.height,
              g = this._priceChartDimensions.y + c * this._priceChartDimensions.height;
            this._drawingContext.fillRect(e + i - o, .5 + (0 | d), n, f - d), this._itemWidth > 1 && this._drawingContext.fillRect(e, .5 + (0 | p), this._itemWidth, Math.max(g - p, .5));
          }
        }, {
          key: "_drawBar",
          value: function value(t, e) {
            var i = this._itemWidth / 2 || .5,
              n = this._itemWidth > 1 ? 1 : .5,
              o = n / 2;
            this._drawingContext.fillStyle = t.bullish ? this._configuration.bullish_color : this._configuration.bearish_color;
            var r = Math.max(t.high, t.low),
              a = Math.min(t.high, t.low),
              s = 1 - (r - this._lowerPriceBound) / this._priceBoundsSpan,
              h = 1 - (a - this._lowerPriceBound) / this._priceBoundsSpan,
              u = 1 - (t.open - this._lowerPriceBound) / this._priceBoundsSpan,
              l = 1 - (t.close - this._lowerPriceBound) / this._priceBoundsSpan,
              _ = this._priceChartDimensions.y + s * this._priceChartDimensions.height,
              c = this._priceChartDimensions.y + h * this._priceChartDimensions.height,
              d = this._priceChartDimensions.y + u * this._priceChartDimensions.height,
              f = this._priceChartDimensions.y + l * this._priceChartDimensions.height;
            this._drawingContext.fillRect(e + i - o, .5 + (0 | _), n, c - _), this._itemWidth > 1 && (this._drawingContext.fillRect(e, .5 + (0 | d), i, n), this._drawingContext.fillRect(e + i, .5 + (0 | f), i, n));
          }
        }, {
          key: "_drawBackground",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawBackground", this).call(this, t);
          }
        }, {
          key: "_drawChart",
          value: function value(t) {
            if (h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawChart", this).call(this, t), this._data.hasData && (t || this.indicesInvalidated || this.boundsInvalidated || this._dimensionsInvalidated)) {
              var i = this._itemWidth + this._itemMargin,
                n = this._drawEndIndex - this._drawStartIndex,
                o = this._priceChartDimensions.width / i | 0,
                r = this._priceChartDimensions.x,
                a = [],
                s = [],
                u = [],
                l = [],
                _ = [];
              o > n && (r += (o - n) * i | 0);
              for (var c = this._drawStartIndex; c < this._drawEndIndex; c++) {
                var d = this._data.getItemAt(c),
                  f = r + (c - this._drawStartIndex) * i,
                  p = f + (this._itemWidth / 2 | 0);
                if ("candlestick" === this._chartType) this._drawCandlestick(d, f);else if ("bar" === this._chartType) this._drawBar(d, f);else {
                  var g = this._priceChartDimensions.y + (1 - (d.close - this._lowerPriceBound) / this._priceBoundsSpan) * this._priceChartDimensions.height;
                  a.push([p, g]);
                }
                if (this._drawSimpleMovingAverage || this._drawBollingerBands) {
                  var v = this._priceChartDimensions.y + (1 - (d.simpleMovingAverage - this._lowerPriceBound) / this._priceBoundsSpan) * this._priceChartDimensions.height;
                  s.push([p, v]);
                }
                if (this._drawExponentialMovingAverage) {
                  var y = this._priceChartDimensions.y + (1 - (d.exponentialMovingAverage - this._lowerPriceBound) / this._priceBoundsSpan) * this._priceChartDimensions.height;
                  u.push([p, y]);
                }
                if (this._drawBollingerBands) {
                  var b = this._priceChartDimensions.y + (1 - (d.simpleMovingAverage + d.standardDeviation * this._configuration.bollinger_standard_deviation_offset - this._lowerPriceBound) / this._priceBoundsSpan) * this._priceChartDimensions.height,
                    w = this._priceChartDimensions.y + (1 - (d.simpleMovingAverage - d.standardDeviation * this._configuration.bollinger_standard_deviation_offset - this._lowerPriceBound) / this._priceBoundsSpan) * this._priceChartDimensions.height;
                  l.push([p, b]), _.push([p, w]);
                }
              }
              if ("line" === this._chartType) {
                var x = this._useGradient && a.length > 0 ? this._createGradient(a) : null;
                m.default.drawPath(this._drawingContext, a, x, this._configuration.price_line_color, 1);
              }
              if ((this._drawSimpleMovingAverage || this._drawBollingerBands) && m.default.drawPath(this._drawingContext, s, null, this._configuration.sma_line_color, 1), this._drawExponentialMovingAverage && m.default.drawPath(this._drawingContext, u, null, this._configuration.ema_line_color, 1), this._drawBollingerBands && (m.default.drawPath(this._drawingContext, l, null, this._configuration.bollinger_band_upper_line_color, 1), m.default.drawPath(this._drawingContext, _, null, this._configuration.bollinger_band_lower_line_color, 1)), this._marketPrice >= this._lowerPriceBound && this._marketPrice <= this._upperPriceBound) {
                var k = .5 + (this._priceChartDimensions.y + (1 - (this._marketPrice - this._lowerPriceBound) / this._priceBoundsSpan) * this._priceChartDimensions.height | 0);
                this._drawingContext.beginPath(), this._drawingContext.strokeStyle = this._configuration.market_price_line_color, this._drawingContext.lineWidth = .5, this._drawingContext.setLineDash([6, 4]), this._drawingContext.moveTo(this._priceChartDimensions.x, k), this._drawingContext.lineTo(this._priceChartDimensions.x + this._priceChartDimensions.width, k), this._drawingContext.stroke(), this._drawingContext.setLineDash([]);
              }
            }
          }
        }, {
          key: "_createGradient",
          value: function value(t) {
            var e = this._configuration.first_gradient_color,
              i = this._configuration.second_gradient_color,
              n = t.reduce(function (t, e) {
                return e[1] > t ? e[1] : t;
              }, t[0][1]),
              o = t.reduce(function (t, e) {
                return e[1] < t ? e[1] : t;
              }, t[0][1]),
              r = t.reduce(function (t, e) {
                return e[0] > t ? e[0] : t;
              }, t[0][0]),
              a = r / 2,
              s = o,
              h = r / 2,
              u = n;
            if (!(isNaN(a) || isNaN(s) || isNaN(h) || isNaN(u))) {
              var l = this._drawingContext.createLinearGradient(a, s, h, u);
              return l.addColorStop(0, e), l.addColorStop(1, i), l;
            }
          }
        }, {
          key: "_drawLabels",
          value: function value(t) {
            if (this._data.hasData && (this.indicesInvalidated = this._computeIndices(), this.boundsInvalidated = this._computeBounds(), this._xLabels.minimum = this._data.getItemAt(this._drawStartIndex).timestamp, this._xLabels.maximum = this._data.getItemAt(this._drawEndIndex).timestamp, this._yLabels.minimum = this._lowerPriceBound, this._yLabels.maximum = this._upperPriceBound, h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawLabels", this).call(this, t), this._useGridLines && this._drawGridLines(t), this._marketPrice >= this._lowerPriceBound && this._marketPrice <= this._upperPriceBound)) {
              var i = m.default.formatNumberToLocale(this._marketPrice, this._yLabels.precision),
                n = this._yLabelDimensions.y + (1 - (this._marketPrice - this._lowerPriceBound) / this._priceBoundsSpan) * this._yLabelDimensions.height | 0;
              this._drawingContext.fillStyle = this._configuration.market_price_background_color, this._drawingContext.fillRect(this._yLabelDimensions.x, n - .75 * this._fontSize, this._yLabelDimensions.width, 1.5 * this._fontSize), this._drawingContext.fillStyle = this._configuration.market_price_label_color, this._drawingContext.fillText("- " + c.default.configuration.currency_character + i, this._yLabelDimensions.x, n + this._fontSize / 4);
            }
          }
        }, {
          key: "_drawGridLines",
          value: function value(t) {
            var e = this,
              i = c.default.configuration.price_history.grid_lines_color,
              n = c.default.configuration.price_history.grid_lines_dashed ? [5, 3] : [];
            this._drawingContext.setLineDash(n), this._drawingContext.lineWidth = 1, this._drawingContext.beginPath(), this._yLabels.tickPoints.forEach(function (t) {
              e._drawingContext.moveTo(e._xLabelDimensions.width, t - 2.5), e._drawingContext.lineTo(0, t - 2.5);
            }), this._xLabels.tickPoints.forEach(function (t) {
              e._drawingContext.moveTo(t + .5, e._yLabelDimensions.y + e._yLabelDimensions.height), e._drawingContext.lineTo(t + .5, e._yLabelDimensions.y);
            }), this._drawingContext.strokeStyle = i, this._drawingContext.stroke(), this._drawingContext.setLineDash([]);
          }
        }, {
          key: "_drawBorders",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawBorders", this).call(this, t), this._drawingContext.fillStyle = this._configuration.border_secondary_color, this._drawingContext.fillRect(this._infoDimensions.x, this._infoDimensions.y + this._infoDimensions.height - 1, this._infoDimensions.width, 1), this._drawingContext.fillRect(this._xLabelDimensions.x, this._xLabelDimensions.y, this._xLabelDimensions.width, 1), this._drawingContext.fillRect(this._yLabelDimensions.x, this._yLabelDimensions.y, 1, this._yLabelDimensions.height);
          }
        }, {
          key: "_updateInfo",
          value: function value(t) {
            var e = (this._mouseX - this._priceChartDimensions.x) / this._priceChartDimensions.width,
              i = this._drawEndIndex - this._drawStartIndex + 1,
              n = Math.floor(i * e);
            n = Math.min(Math.max(n, 0), i);
            var o = this._drawStartIndex + n,
              r = this._data.getItemAt(o),
              a = [],
              s = m.default.formatNumberToLocale(this._marketPrice, this._configuration.info_precision);
            if (r && void 0 === t) {
              var h = m.default.formatNumberToLocale(r.open, this._configuration.info_precision),
                u = m.default.formatNumberToLocale(r.close, this._configuration.info_precision),
                l = m.default.formatNumberToLocale(r.high, this._configuration.info_precision),
                _ = m.default.formatNumberToLocale(r.low, this._configuration.info_precision),
                d = m.default.formatNumberToLocale(r.volume, this._configuration.info_precision),
                f = c.default.configuration.currency_character;
              a.push('<label class="ac-price">' + this._infoLabels[0] + "</label> " + f + s), a.push('<label class="ac-open">' + this._infoLabels[1] + "</label> " + f + h), a.push('<label class="ac-close">' + this._infoLabels[2] + "</label> " + f + u), a.push('<label class="ac-high">' + this._infoLabels[3] + "</label> " + f + l), a.push('<label class="ac-low">' + this._infoLabels[4] + "</label> " + f + _), a.push('<label class="ac-volume">' + this._infoLabels[5] + "</label> " + d);
            } else a = ['<label class="ac-price">' + this._infoLabels[0] + "</label> " + c.default.configuration.currency_character + s, "", "", "", "", ""];
            if (this._infoElement.hasChildNodes()) for (var p = this._infoElement.childNodes, g = 0; g < p.length; g++) p[g].innerHTML = a[g];
          }
        }, {
          key: "_onMouseLeave",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseLeave", this).call(this, t), t.target === this._element && this._updateInfo("");
          }
        }, {
          key: "_onMouseDown",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseDown", this).call(this, t), this._updateInfo();
          }
        }, {
          key: "_onMouseMove",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseMove", this).call(this, t);
            var i = t.target.offsetParent && t.target.offsetParent.classList.contains("price-history");
            !this._mouseIsDown && i && this._updateInfo();
          }
        }, {
          key: "_unregisterListeners",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_unregisterListeners", this).call(this);
          }
        }, {
          key: "marketPrice",
          get: function get() {
            return this._marketPrice;
          },
          set: function set(t) {
            this._marketPrice !== t && (this._marketPrice = t, this._updateInfo(), this._draw(!0));
          }
        }, {
          key: "drawSimpleMovingAverage",
          get: function get() {
            return this._drawSimpleMovingAverage;
          },
          set: function set(t) {
            this._drawSimpleMovingAverage !== t && (this._drawSimpleMovingAverage = t, this._draw(!0));
          }
        }, {
          key: "drawExponentialMovingAverage",
          get: function get() {
            return this._drawExponentialMovingAverage;
          },
          set: function set(t) {
            this._drawExponentialMovingAverage !== t && (this._drawExponentialMovingAverage = t, this._draw(!0));
          }
        }, {
          key: "drawBollingerBands",
          get: function get() {
            return this._drawBollingerBands;
          },
          set: function set(t) {
            this._drawBollingerBands !== t && (this._drawBollingerBands = t, this._draw(!0));
          }
        }, {
          key: "chartType",
          get: function get() {
            return this._chartType;
          },
          set: function set(t) {
            this._chartType = t, this._draw(!0);
          }
        }]), e;
      }(l.default);
    e.default = v, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = i(1),
      u = n(h),
      l = i(2),
      _ = i(0),
      c = n(_),
      d = i(16),
      f = n(d),
      p = i(3),
      g = n(p),
      m = function (t) {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
            s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "sans-serif",
            h = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 12,
            u = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : "#ffffff",
            l = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : "",
            _ = arguments.length > 8 && void 0 !== arguments[8] && arguments[8];
          o(this, e);
          var c = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return null !== t && (c._dimensions = t), c._type = i, c._orientation = n, c._precision = a, c._fontFace = s, c._fontSize = h, c._fontColor = u, c._tickPrefix = l, c._abbreviate = _, c._minimum = 0, c._maximum = 0, c._span = 0, c._tickPoints = [], c;
        }
        return a(e, t), s(e, [{
          key: "_drawHorizontal",
          value: function value(t) {
            var e = this,
              i = this._dimensions.width / (10 * this._fontSize) | 0;
            if (this._tickPoints = [], this._type === l.AxisLabelingType.DATETIME) for (var n = this._span / i | 0, o = this._maximum; o > this._minimum && o - n > this._minimum;) {
              o -= n;
              var r = (o - this._minimum) / this._span,
                a = this._dimensions.x + r * this._dimensions.width,
                s = this._dimensions.y;
              this._tickPoints.push(a);
              var h = new Date(1e3 * o),
                u = (h.getUTCDate(), c.default.configuration.date_format_months[h.getMonth()] + " " + h.getDate()),
                _ = t.measureText(u).width / 2 | 0;
              t.fillRect(a, s, 1, 5), t.fillText(u, a - _, s + this._fontSize + 5);
            } else {
              f.default.generate(this._minimum, this._maximum, i, !1).forEach(function (i) {
                var n = (i - e._minimum) / e._span,
                  o = e._dimensions.x + n * e._dimensions.width,
                  r = e._dimensions.y,
                  a = void 0;
                if (e._tickPoints.push(o), e._type === l.AxisLabelingType.DATETIME) {
                  var s = new Date(1e3 * i);
                  s.getUTCDate(), c.default.configuration.date_format_months[s.getMonth()], s.getDate();
                  console.log(i);
                } else a = e._abbreviate ? g.default.abbreviateNumber(i) : g.default.formatNumberToLocale(i, e._precision), "" !== e._tickPrefix && (a = e._tickPrefix + a);
                var h = t.measureText(a).width / 2 | 0;
                t.fillRect(o, r, 1, 5), t.fillText(a, o - h, r + e._fontSize + 5);
              });
            }
          }
        }, {
          key: "_drawVertical",
          value: function value(t) {
            var e = this,
              i = this._dimensions.height / (2 * this._fontSize) | 0,
              n = f.default.generate(this._minimum, this._maximum, i, !1);
            this._tickPoints = [], n.forEach(function (i) {
              var n = 1 - (i - e._minimum) / e._span,
                o = e._dimensions.x,
                r = e._dimensions.y + 2 + n * e._dimensions.height;
              e._tickPoints.push(r), i % 1 != 0 && e._precision > 0 && (i = i.toFixed(e._precision));
              var a = void 0;
              a = e._abbreviate ? g.default.abbreviateNumber(i) : g.default.formatNumberToLocale(i, e._precision), "" !== e._tickPrefix && (a = e._tickPrefix + a), a = "- " + a, t.fillText(a, o, r);
            });
          }
        }, {
          key: "draw",
          value: function value(t) {
            void 0 !== t && null !== this._dimensions && 0 !== this._type && 0 !== this._span && 0 !== this._dimensions.width && 0 !== this._dimensions.height && (t.font = this._font, t.fillStyle = this._fontColor, this._orientation === l.AxisLabelingOrientation.HORIZONTAL ? this._drawHorizontal(t) : this._orientation === l.AxisLabelingOrientation.VERTICAL && this._drawVertical(t));
          }
        }, {
          key: "dimensions",
          get: function get() {
            return this._dimensions;
          },
          set: function set(t) {
            this._dimensions !== t && (this._dimensions = t);
          }
        }, {
          key: "type",
          get: function get() {
            return this._type;
          },
          set: function set(t) {
            this._type !== t && (this._type = t);
          }
        }, {
          key: "orientation",
          get: function get() {
            return this._orientation;
          },
          set: function set(t) {
            this._orientation !== t && (this._orientation = t);
          }
        }, {
          key: "precision",
          get: function get() {
            return this._precision;
          },
          set: function set(t) {
            this._precision !== t && (this._precision = t);
          }
        }, {
          key: "fontFace",
          get: function get() {
            return this._fontFace;
          },
          set: function set(t) {
            this._fontFace !== t && (this._fontFace = t);
          }
        }, {
          key: "fontSize",
          get: function get() {
            return this._fontSize;
          },
          set: function set(t) {
            this._fontSize !== t && (this._fontSize = t);
          }
        }, {
          key: "fontColor",
          get: function get() {
            return this._fontColor;
          },
          set: function set(t) {
            this._fontColor !== t && (this._fontColor = t);
          }
        }, {
          key: "font",
          get: function get() {
            return this._font;
          },
          set: function set(t) {
            this._font !== t && (this._font = t);
          }
        }, {
          key: "tickPrefix",
          get: function get() {
            return this._tickPrefix;
          },
          set: function set(t) {
            this._tickPrefix !== t && (this._tickPrefix = t);
          }
        }, {
          key: "abbreviate",
          get: function get() {
            return this._abbreviate;
          },
          set: function set(t) {
            this._abbreviate !== t && (this._abbreviate = t);
          }
        }, {
          key: "minimum",
          get: function get() {
            return this._minimum;
          },
          set: function set(t) {
            this._minimum !== t && (this._minimum = t, this._span = this._maximum - this._minimum);
          }
        }, {
          key: "maximum",
          get: function get() {
            return this._maximum;
          },
          set: function set(t) {
            this._maximum !== t && (this._maximum = t, this._span = this._maximum - this._minimum);
          }
        }, {
          key: "tickPoints",
          get: function get() {
            return this._tickPoints;
          }
        }]), e;
      }(u.default);
    e.default = m, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      r = function () {
        function t() {
          n(this, t);
        }
        return o(t, null, [{
          key: "getBases",
          value: function value() {
            return [1, 2, 2.5, 5];
          }
        }, {
          key: "getNiceInterval",
          value: function value(e, i, n) {
            var o = (i - e) / n,
              r = Math.log10(o),
              a = [Math.floor(r), Math.ceil(r)],
              s = 1 / 0;
            return t.getBases().forEach(function (t) {
              a.forEach(function (e) {
                var i = t * Math.pow(10, e);
                Math.abs(o - i) < Math.abs(o - s) && (s = i);
              });
            }), s;
          }
        }, {
          key: "generate",
          value: function value(e, i, n, o) {
            var r = e < 10 && i < 10;
            r && (e *= 1e3, i *= 1e3);
            for (var a = t.getNiceInterval(e, i, n), s = Math.ceil(e / a) * a, h = [s]; s < i && s + a < i;) s += a, h.push(s);
            var u = Math.pow(10, Math.ceil(Math.log10(a)) + 1);
            return h = h.map(function (t) {
              var e = Math.round(t * u) / u;
              return r && (e /= 1e3), e;
            }), o && (r && (e /= 1e3, i /= 1e3), h[0] = e, h[h.length - 1] = i), h;
          }
        }]), t;
      }();
    e.default = r, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = function t(e, i, n) {
        null === e && (e = Function.prototype);
        var o = Object.getOwnPropertyDescriptor(e, i);
        if (void 0 === o) {
          var r = Object.getPrototypeOf(e);
          return null === r ? void 0 : t(r, i, n);
        }
        if ("value" in o) return o.value;
        var a = o.get;
        if (void 0 !== a) return a.call(n);
      },
      u = i(4),
      l = n(u),
      _ = i(0),
      c = n(_),
      d = i(2),
      f = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, i));
          return n._upperVolumeBound = 0, n._configuration = Object.assign({}, c.default.configuration.volume_history), n._build(), n._registerListeners(), n;
        }
        return a(e, t), s(e, [{
          key: "_build",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_build", this).call(this), this._element.classList.add("volume-history"), this._yLabels.type = d.AxisLabelingType.NUMBER, this._yLabels.fontFace = this._fontFace, this._yLabels.fontSize = this._fontSize, this._yLabels.fontColor = this._configuration.y_label_color, this._yLabels.abbreviate = !0;
          }
        }, {
          key: "_computeDimensions",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_computeDimensions", this).call(this), this._draw();
          }
        }, {
          key: "_computeBounds",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_computeBounds", this).call(this);
            for (var t = 0, i = this._drawStartIndex; i < this._drawEndIndex; i++) {
              var n = this._data.getItemAt(i);
              n.volume > t && (t = n.volume);
            }
            return this._upperVolumeBound !== t && (this._upperVolumeBound = t, !0);
          }
        }, {
          key: "_drawVolumeItem",
          value: function value(t, e) {
            this._drawingContext.fillStyle = t.bullish ? this._configuration.bullish_color : this._configuration.bearish_color;
            var i = this._chartDimensions.y + (1 - t.volume / this._upperVolumeBound) * this._chartDimensions.height,
              n = this._chartDimensions.y + this._chartDimensions.height - i;
            this._drawingContext.fillRect(e, i, this._itemWidth, n);
          }
        }, {
          key: "_drawChart",
          value: function value(t) {
            if (h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawChart", this).call(this, t), this._data.hasData) {
              var i = this._computeIndices(),
                n = this._computeBounds();
              if (t || i || n || this._dimensionsInvalidated) {
                var o = this._itemWidth + this._itemMargin,
                  r = this._drawEndIndex - this._drawStartIndex,
                  a = this._chartDimensions.width / o | 0,
                  s = this._chartDimensions.x;
                a > r && (s += (a - r) * o | 0);
                for (var u = this._drawStartIndex; u < this._drawEndIndex; u++) {
                  var l = this._data.getItemAt(u),
                    _ = s + (u - this._drawStartIndex) * o;
                  this._drawVolumeItem(l, _);
                }
              }
            }
          }
        }, {
          key: "_drawLabels",
          value: function value(t) {
            this._data.hasData && (this._yLabels.minimum = 0, this._yLabels.maximum = this._upperVolumeBound, h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawLabels", this).call(this, t));
          }
        }, {
          key: "_drawBorders",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawBorders", this).call(this, t), this._drawingContext.fillStyle = this._configuration.border_secondary_color, this._drawingContext.fillRect(this._yLabelDimensions.x, this._yLabelDimensions.y, 1, this._yLabelDimensions.height);
          }
        }, {
          key: "_unregisterListeners",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_unregisterListeners", this).call(this);
          }
        }]), e;
      }(l.default);
    e.default = f, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = function t(e, i, n) {
        null === e && (e = Function.prototype);
        var o = Object.getOwnPropertyDescriptor(e, i);
        if (void 0 === o) {
          var r = Object.getPrototypeOf(e);
          return null === r ? void 0 : t(r, i, n);
        }
        if ("value" in o) return o.value;
        var a = o.get;
        if (void 0 !== a) return a.call(n);
      },
      u = i(4),
      l = n(u),
      _ = i(0),
      c = n(_),
      d = i(2),
      f = i(3),
      p = n(f),
      g = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, i));
          return n._upperMACDBound = 0, n._configuration = Object.assign({}, c.default.configuration.macd_history), n._build(), n._registerListeners(), n;
        }
        return a(e, t), s(e, [{
          key: "_build",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_build", this).call(this), this._element.classList.add("macd-history"), this._yLabels.type = d.AxisLabelingType.NUMBER, this._yLabels.fontFace = this._fontFace, this._yLabels.fontSize = this._fontSize, this._yLabels.fontColor = this._configuration.y_label_color;
          }
        }, {
          key: "_computeDimensions",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_computeDimensions", this).call(this), this._draw();
          }
        }, {
          key: "_computeBounds",
          value: function value() {
            for (var t = (Number.MAX_SAFE_INTEGER, 0), e = this._drawStartIndex; e < this._drawEndIndex; e++) {
              var i = this._data.getItemAt(e);
              Math.abs(i.macdIndicator) > t && (t = Math.abs(i.macdIndicator)), Math.abs(i.macdSignal) > t && (t = Math.abs(i.macdIndicator)), Math.abs(i.macdDisparity) > t && (t = Math.abs(i.macdDisparity));
            }
            return this._upperMACDBound !== t && (this._upperMACDBound = t, !0);
          }
        }, {
          key: "_drawMACD",
          value: function value(t, e) {
            var i = (this._chartDimensions, this._chartDimensions.y + this._chartDimensions.height / 2),
              n = Math.abs(t.macdDisparity) / this._upperMACDBound * (this._chartDimensions.height / 2);
            t.macdDisparity >= 0 ? (this._drawingContext.fillStyle = this._configuration.histogram_positive_color, i -= n) : this._drawingContext.fillStyle = this._configuration.histogram_negative_color, this._drawingContext.fillRect(e, i, this._itemWidth, n);
          }
        }, {
          key: "_drawChart",
          value: function value(t) {
            if (h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawChart", this).call(this), this._data.hasData) {
              var i = this._computeIndices(),
                n = this._computeBounds();
              if (t || i || n || this._dimensionsInvalidated) {
                var o = this._itemWidth + this._itemMargin,
                  r = this._drawEndIndex - this._drawStartIndex,
                  a = this._chartDimensions.width / o | 0,
                  s = this._chartDimensions.x,
                  u = [],
                  l = [];
                a > r && (s += (a - r) * o | 0);
                for (var _ = this._drawStartIndex; _ < this._drawEndIndex; _++) {
                  var c = this._data.getItemAt(_),
                    d = s + (_ - this._drawStartIndex) * o,
                    f = d + (this._itemWidth / 2 | 0),
                    g = this._chartDimensions.y + (1 - (this._upperMACDBound + c.macdIndicator) / (2 * this._upperMACDBound)) * this._chartDimensions.height,
                    m = this._chartDimensions.y + (1 - (this._upperMACDBound + c.macdSignal) / (2 * this._upperMACDBound)) * this._chartDimensions.height;
                  u.push([f, g]), l.push([f, m]), this._drawMACD(c, d);
                }
                p.default.drawPath(this._drawingContext, u, null, this._configuration.indicator_line_color, 1), p.default.drawPath(this._drawingContext, l, null, this._configuration.signal_line_color, 1);
              }
            }
          }
        }, {
          key: "_drawLabels",
          value: function value(t) {
            this._data.hasData && (this._yLabels.minimum = -this._upperMACDBound, this._yLabels.maximum = this._upperMACDBound, h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawLabels", this).call(this, t));
          }
        }, {
          key: "_drawBorders",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawBorders", this).call(this, t), this._drawingContext.fillStyle = this._configuration.border_secondary_color, this._drawingContext.fillRect(this._yLabelDimensions.x, this._yLabelDimensions.y, 1, this._yLabelDimensions.height), this._drawingContext.fillStyle = this._configuration.zero_line_color, this._drawingContext.fillRect(this._chartDimensions.x, this._chartDimensions.y + this._chartDimensions.height / 2, this._chartDimensions.width, 1);
          }
        }, {
          key: "_unregisterListeners",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_unregisterListeners", this).call(this);
          }
        }]), e;
      }(l.default);
    e.default = g, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = function t(e, i, n) {
        null === e && (e = Function.prototype);
        var o = Object.getOwnPropertyDescriptor(e, i);
        if (void 0 === o) {
          var r = Object.getPrototypeOf(e);
          return null === r ? void 0 : t(r, i, n);
        }
        if ("value" in o) return o.value;
        var a = o.get;
        if (void 0 !== a) return a.call(n);
      },
      u = i(5),
      l = n(u),
      _ = i(0),
      c = n(_),
      d = i(2),
      f = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
          return n._fullRangeCanvas = null, n._fullRangeContext = null, n._data = i, n._rangeStartIndex = 0, n._rangeEndIndex = 100, n._range = null, n._leftHandle = null, n._rightHandle = null, n._dragMode = null, n._dragStartIndex = 0, n._dragStartSpan = 0, n._configuration = Object.assign({}, c.default.configuration.range_selector), n._build(), n._registerListeners(), n;
        }
        return a(e, t), s(e, [{
          key: "_build",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_build", this).call(this), this._element.classList.add("range-selector"), this._fullRangeCanvas = document.createElement("canvas"), this._fullRangeContext = this._fullRangeCanvas.getContext("2d", {
              antialias: !1,
              alpha: !1
            }), this._fullRangeContext.imageSmoothingEnabled = !1, this._fullRangeContext.imageSmoothingQuality = "low", this._range = document.createElement("div"), this._range.classList.add("range"), this._range.style.cursor = "move", this._range.style.left = "-5000px", this._leftHandle = document.createElement("button"), this._leftHandle.classList.add("handle"), this._leftHandle.style.cursor = "col-resize", this._leftHandle.style.left = "-5000px", this._rightHandle = document.createElement("button"), this._rightHandle.classList.add("handle"), this._rightHandle.style.cursor = "col-resize", this._rightHandle.style.left = "-5000px", this._element.append(this._range), this._element.append(this._leftHandle), this._element.append(this._rightHandle), this._xLabels.type = d.AxisLabelingType.DATETIME, this._xLabels.fontFace = this._fontFace, this._xLabels.fontSize = this._fontSize, this._xLabels.fontColor = this._configuration.x_label_color;
          }
        }, {
          key: "_computeDimensions",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_computeDimensions", this).call(this), this._draw();
          }
        }, {
          key: "_drawFullRange",
          value: function value() {
            var t = this._data.length - 1;
            this._fullRangeCanvas.width = 2 * this._chartDimensions.width, this._fullRangeCanvas.height = 2 * this._chartDimensions.height, this._fullRangeContext.fillStyle = this._configuration.background_color, this._fullRangeContext.fillRect(0, 0, this._fullRangeCanvas.width, this._fullRangeCanvas.height);
            Math.max(this._fullRangeCanvas.width / t, .05);
            if (this._data.hasData) {
              this._fullRangeContext.strokeStyle = this._configuration.price_line_color, this._fullRangeContext.lineWidth = 1, this._fullRangeContext.beginPath();
              for (var e = 0; e < t; e++) {
                var i = this._data.getItemAt(e),
                  n = e / t * this._fullRangeCanvas.width,
                  o = .5 + ((1 - (i.close - this._data.lowerPriceBound) / this._data.priceBoundsSpan) * this._fullRangeCanvas.height | 0);
                0 === e ? this._fullRangeContext.moveTo(n, o) : this._fullRangeContext.lineTo(n, o);
              }
              this._fullRangeContext.stroke();
            }
          }
        }, {
          key: "_drawBackground",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawBackground", this).call(this, t), this._dimensionsInvalidated && this._drawFullRange(), this._fullRangeCanvas.width && this._fullRangeCanvas.height && this._drawingContext.drawImage(this._fullRangeCanvas, 0, 0, this._chartDimensions.width, this._chartDimensions.height);
          }
        }, {
          key: "_drawChart",
          value: function value(t) {
            if (h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawChart", this).call(this, t), !this._data.hasData) return this._range.style.left = "-5000px", this._leftHandle.style.left = "-5000px", void (this._rightHandle.style.left = "-5000px");
            var i = this._leftHandle.offsetWidth,
              n = this._leftHandle.offsetHeight,
              o = this._rangeStartIndex / (this._data.length - 1),
              r = this._rangeEndIndex / (this._data.length - 1),
              a = this._leftHandle.style;
            a.left = this._chartDimensions.x / this._pixelRatio + (o * (this._chartDimensions.width / this._pixelRatio) - i / 2) + "px", a.top = (this._chartDimensions.height / this._pixelRatio - n) / 2 + "px";
            var s = this._rightHandle.style;
            s.left = this._chartDimensions.x / this._pixelRatio + (r * (this._chartDimensions.width / this._pixelRatio) - i / 2) + "px", s.top = (this._chartDimensions.height / this._pixelRatio - n) / 2 + "px";
            var u = this._range.style;
            u.left = this._chartDimensions.x + o * (this._chartDimensions.width / this._pixelRatio) + "px", u.right = this._width / this._pixelRatio - (this._chartDimensions.x / this._pixelRatio + r * (this._chartDimensions.width / this._pixelRatio)) + "px", u.top = this._chartDimensions.y / this._pixelRatio + "px", u.height = this._chartDimensions.height / this._pixelRatio + "px";
          }
        }, {
          key: "_drawLabels",
          value: function value(t) {
            this._data.hasData && (this._xLabels.minimum = this._data.getItemAt(0).timestamp, this._xLabels.maximum = this._data.getItemAt(this._data.length - 1).timestamp, h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawLabels", this).call(this, t));
          }
        }, {
          key: "_drawBorders",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawBorders", this).call(this, t), this._drawingContext.fillStyle = this._configuration.border_secondary_color, this._drawingContext.fillRect(this._xLabelDimensions.x, this._xLabelDimensions.y, this._xLabelDimensions.width, 1);
          }
        }, {
          key: "_registerListeners",
          value: function value() {
            var t = this;
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_registerListeners", this).call(this), this._data.addEventListener("parseComplete", function () {
              t._drawFullRange(), t._draw();
            });
          }
        }, {
          key: "_unregisterListeners",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_unregisterListeners", this).call(this);
          }
        }, {
          key: "_onMouseLeave",
          value: function value(t) {
            t.target === this._element && h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseLeave", this).call(this, t);
          }
        }, {
          key: "_handleDragStart",
          value: function value(t) {
            this._dragMode = t, this._dragStartIndex = this._rangeStartIndex, this._dragStartSpan = this._rangeEndIndex - this._rangeStartIndex;
          }
        }, {
          key: "_handleDrag",
          value: function value() {
            if (0 !== this._mouseDragXDistance) {
              var t = this._mouseDragXDistance / this._chartDimensions.width,
                e = Math.abs(t) * (this._data.length - 1) | 0,
                i = this._rangeStartIndex,
                n = this._rangeEndIndex;
              this._mouseDragXDistance < 0 && (e = -e), this._dragMode === d.RangeSelectorDragMode.PAN ? (i = Math.min(Math.max(this._dragStartIndex + e, 0), this._data.length - 1 - this._dragStartSpan), n = i + this._dragStartSpan) : this._dragMode === d.RangeSelectorDragMode.RESIZE_LEFT ? i = Math.min(Math.max(this._dragStartIndex + e, 0), n) : this._dragMode === d.RangeSelectorDragMode.RESIZE_RIGHT && (n = Math.min(Math.max(this._dragStartIndex + this._dragStartSpan + e, i), this._data.length - 1)), this._rangeStartIndex === i && this._rangeEndIndex === n || (this._rangeStartIndex = i, this._rangeEndIndex = n, this._draw(), this._dragMode === d.RangeSelectorDragMode.PAN && this.dispatchEvent("rangeChanged", this._rangeStartIndex, this._rangeEndIndex));
            }
          }
        }, {
          key: "_handleDragEnd",
          value: function value() {
            this._dragMode !== d.RangeSelectorDragMode.PAN && this._dragMode !== d.RangeSelectorDragMode.RESIZE_LEFT && this._dragMode !== d.RangeSelectorDragMode.RESIZE_RIGHT || this.dispatchEvent("rangeChanged", this._rangeStartIndex, this._rangeEndIndex), this._dragMode = null;
          }
        }, {
          key: "_onMouseMove",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseMove", this).call(this, t), this._mouseIsDown && this._handleDrag();
          }
        }, {
          key: "_onMouseDown",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseDown", this).call(this, t), t.target === this._leftHandle ? this._handleDragStart(d.RangeSelectorDragMode.RESIZE_LEFT) : t.target === this._rightHandle ? this._handleDragStart(d.RangeSelectorDragMode.RESIZE_RIGHT) : t.target === this._range && this._handleDragStart(d.RangeSelectorDragMode.PAN);
          }
        }, {
          key: "_onMouseUp",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseUp", this).call(this, t), this._handleDragEnd();
          }
        }, {
          key: "setRange",
          value: function value(t, e) {
            this._rangeStartIndex = t, this._rangeEndIndex = e, this._draw();
          }
        }, {
          key: "rangeStartIndex",
          get: function get() {
            return this._rangeStartIndex;
          }
        }, {
          key: "rangeEndIndex",
          get: function get() {
            return this._rangeEndIndex;
          }
        }]), e;
      }(l.default);
    e.default = f, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = function t(e, i, n) {
        null === e && (e = Function.prototype);
        var o = Object.getOwnPropertyDescriptor(e, i);
        if (void 0 === o) {
          var r = Object.getPrototypeOf(e);
          return null === r ? void 0 : t(r, i, n);
        }
        if ("value" in o) return o.value;
        var a = o.get;
        if (void 0 !== a) return a.call(n);
      },
      u = i(5),
      l = n(u),
      _ = i(0),
      c = n(_),
      d = i(6),
      f = n(d),
      p = i(2),
      g = i(3),
      m = n(g),
      v = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
          return n._data = i, n._infoElement = null, n._marketPrice = 0, n._lowerPriceBound = Number.MAX_SAFE_INTEGER, n._upperPriceBound = 0, n._upperCountBound = 0, n._priceBoundsSpan = 0, n._configuration = Object.assign({}, c.default.configuration.order_book_depth), n._infoDimensions = new f.default(), n._depthChartDimensions = new f.default(), n._infoXOffset = -1, n._infoTargetPrice = -1, n._parseTimeout = null, n._build(), n._registerListeners(), n;
        }
        return a(e, t), s(e, [{
          key: "_build",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_build", this).call(this), this._element.classList.add("order-book-depth"), this._infoElement = document.createElement("div"), this._infoElement.classList.add("info"), this._element.append(this._infoElement), this._xLabels.type = p.AxisLabelingType.CURRENCY, this._xLabels.fontFace = this._fontFace, this._xLabels.fontSize = this._fontSize, this._xLabels.fontColor = this._configuration.x_label_color, this._xLabels.tickPrefix = "$", this._yLabels.type = p.AxisLabelingType.NUMBER, this._yLabels.fontFace = this._fontFace, this._yLabels.fontSize = this._fontSize, this._yLabels.fontColor = this._configuration.y_label_color;
          }
        }, {
          key: "_computeDimensions",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_computeDimensions", this).call(this), this._configuration.info_height % 1 == 0 ? this._infoDimensions.height = this._configuration.info_height * this._pixelRatio : this._infoDimensions.height = this._chartDimensions.height * this._configuration.info_height | 0, this._infoDimensions.width = this._chartDimensions.width, this._infoDimensions.x = this._chartDimensions.x, this._infoDimensions.y = this._chartDimensions.y, this._depthChartDimensions.x = this._chartDimensions.x, this._depthChartDimensions.y = this._chartDimensions.y + this._infoDimensions.height, this._depthChartDimensions.width = this._chartDimensions.width, this._depthChartDimensions.height = this._chartDimensions.height - this._infoDimensions.height - 1;
            var t = this._infoElement.style;
            t.top = this._infoDimensions.y / this._pixelRatio + "px", t.left = this._infoDimensions.x / this._pixelRatio + "px", t.width = this._infoDimensions.width / this._pixelRatio + "px", t.height = this._infoDimensions.height / this._pixelRatio + "px", this._yLabelDimensions.y = this._depthChartDimensions.y, this._yLabelDimensions.height = this._depthChartDimensions.height, this._draw();
          }
        }, {
          key: "_computeBounds",
          value: function value() {
            var t = Math.abs(this._marketPrice - this._data.lowerPriceBound),
              e = Math.abs(this._marketPrice - this._data.upperPriceBound),
              i = Math.max(t, e),
              n = this._marketPrice - i,
              o = this._marketPrice + i,
              r = this._data.upperCountBound;
            return (this._lowerPriceBound !== n || this._upperPriceBound !== o || this._upperCountBound !== r) && (this._lowerPriceBound = n, this._upperPriceBound = o, this._upperCountBound = r, this._priceBoundsSpan = this._upperPriceBound - this._lowerPriceBound, !0);
          }
        }, {
          key: "_drawChart",
          value: function value(t) {
            if (h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawChart", this).call(this, t), this._data.hasData) {
              var i = this._computeBounds();
              if (t || i || this._dimensionsInvalidated) {
                var n = (this._marketPrice - this._lowerPriceBound) / this._priceBoundsSpan,
                  o = 1,
                  r = this._depthChartDimensions.x + (this._depthChartDimensions.width * n | 0),
                  a = this._depthChartDimensions.y + (this._depthChartDimensions.height * o | 0),
                  s = [[r, a]],
                  u = !0,
                  l = !1,
                  _ = void 0;
                try {
                  for (var c, d = this._data.askData[Symbol.iterator](); !(u = (c = d.next()).done); u = !0) {
                    var f = c.value;
                    if (f.price > this._upperPriceBound) break;
                    n = (f.price - this._lowerPriceBound) / this._priceBoundsSpan, o = 1 - f.cumulativeCount / this._upperCountBound, r = this._depthChartDimensions.x + (this._depthChartDimensions.width * n | 0), a = this._depthChartDimensions.y + (this._depthChartDimensions.height * o | 0), s.push([r, a]);
                  }
                } catch (t) {
                  l = !0, _ = t;
                } finally {
                  try {
                    !u && d.return && d.return();
                  } finally {
                    if (l) throw _;
                  }
                }
                r < this._depthChartDimensions.x + this._depthChartDimensions.width && s.push([this._depthChartDimensions.x + this._depthChartDimensions.width, a]), s.push([this._depthChartDimensions.x + this._depthChartDimensions.width, this._depthChartDimensions.y + this._depthChartDimensions.height]), s.push([s[0][0], this._depthChartDimensions.y + this._depthChartDimensions.height]);
                var p = (this._marketPrice - this._lowerPriceBound) / this._priceBoundsSpan,
                  g = 1,
                  v = this._depthChartDimensions.x + (this._depthChartDimensions.width * p | 0),
                  y = this._depthChartDimensions.y + (this._depthChartDimensions.height * g | 0),
                  b = [[v, y]],
                  w = !0,
                  x = !1,
                  k = void 0;
                try {
                  for (var D, C = this._data.bidData[Symbol.iterator](); !(w = (D = C.next()).done); w = !0) {
                    var E = D.value;
                    if (E.price < this._lowerPriceBound) break;
                    p = (E.price - this._lowerPriceBound) / this._priceBoundsSpan, g = 1 - E.cumulativeCount / this._upperCountBound, v = this._depthChartDimensions.x + (this._depthChartDimensions.width * p | 0), y = this._depthChartDimensions.y + (this._depthChartDimensions.height * g | 0), b.push([v, y]);
                  }
                } catch (t) {
                  x = !0, k = t;
                } finally {
                  try {
                    !w && C.return && C.return();
                  } finally {
                    if (x) throw k;
                  }
                }
                v > this._depthChartDimensions.x && b.push([this._depthChartDimensions.x, y]), b.push([this._depthChartDimensions.x, this._depthChartDimensions.y + this._depthChartDimensions.height]), b.push([b[0][0], this._depthChartDimensions.y + this._depthChartDimensions.height]), m.default.drawPath(this._drawingContext, s, this._configuration.ask_fill_color, this._configuration.ask_line_color, 1), m.default.drawPath(this._drawingContext, b, this._configuration.bid_fill_color, this._configuration.bid_line_color, 1);
              }
            }
          }
        }, {
          key: "_drawLabels",
          value: function value(t) {
            if (this._data.hasData) {
              this._xLabels.minimum = this._lowerPriceBound, this._xLabels.maximum = this._upperPriceBound, this._yLabels.minimum = 0, this._yLabels.maximum = this._upperCountBound, h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawLabels", this).call(this, t);
              var i = (this._marketPrice - this._lowerPriceBound) / this._priceBoundsSpan,
                n = this._depthChartDimensions.x + (i * this._depthChartDimensions.width | 0),
                o = this._marketPrice;
              o % 1 != 0 && (o = o.toFixed(this._configuration.x_label_precision)), o = c.default.configuration.currency_character + o;
              var r = this._drawingContext.measureText(o).width / 2 | 0;
              this._drawingContext.fillStyle = this._configuration.market_price_color, this._drawingContext.fillText(o, n - r, this._infoDimensions.height + this._fontSize + 4), this._drawingContext.fillRect(n, this._infoDimensions.height + 2 * this._fontSize, 1, this._depthChartDimensions.height - 2 * this._fontSize);
            }
          }
        }, {
          key: "_drawBorders",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_drawBorders", this).call(this), this._drawingContext.fillStyle = this._configuration.border_secondary_color, this._drawingContext.fillRect(this._infoDimensions.x, this._infoDimensions.y + this._infoDimensions.height - 1, this._infoDimensions.width, 1), this._drawingContext.fillRect(this._xLabelDimensions.x, this._xLabelDimensions.y, this._xLabelDimensions.width, 1), this._drawingContext.fillRect(this._yLabelDimensions.x, this._yLabelDimensions.y, 1, this._yLabelDimensions.height);
          }
        }, {
          key: "_updateInfo",
          value: function value(t) {
            var e = this._infoXOffset / this._depthChartDimensions.width,
              i = this._lowerPriceBound + e * this._priceBoundsSpan,
              n = void 0;
            if (this._infoTargetPrice !== i) {
              var o = null;
              if (e < .5 ? (n = "bid", o = this._data.getClosestItem("bid", i)) : (n = "ask", o = this._data.getClosestItem("ask", i)), o) {
                var r = m.default.formatUSD(o.cumulativeCost / o.cumulativeCount, this._configuration.info_precision),
                  a = o.cumulativeCount;
                a % 1 != 0 && (a = a.toFixed(this._configuration.info_precision));
                var s = m.default.formatUSD(o.cumulativeCost, this._configuration.info_precision);
                this._infoElement.innerHTML = "<em>avg:&nbsp;</em><strong>" + c.default.configuration.currency_character + r + "</strong>&nbsp;-&nbsp;<em>" + ("bid" === n ? "sell" : "buy") + ":&nbsp;</em><strong>" + a + "</strong><em>&nbsp;for:&nbsp;</em><strong>" + c.default.configuration.currency_character + s + "</strong>";
              }
            }
          }
        }, {
          key: "_registerListeners",
          value: function value() {
            var t = this;
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_registerListeners", this).call(this), this._data.addEventListener("parseComplete", function () {
              t._draw(!0);
            }), this._data.addEventListener("addComplete", function () {
              null === t._parseTimeout && (t._parseTimeout = setTimeout(function () {
                t._draw(!0), t._parseTimeout = null;
              }, 1e3));
            });
          }
        }, {
          key: "_unregisterListeners",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_unregisterListeners", this).call(this);
          }
        }, {
          key: "_onMouseMove",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseMove", this).call(this, t);
            var i = this._mouseX - this._depthChartDimensions.x;
            this._infoXOffset !== i && (this._infoXOffset = this._mouseX - this._depthChartDimensions.x, this._updateInfo());
          }
        }, {
          key: "_onMouseDown",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "_onMouseMove", this).call(this, t);
            var i = this._mouseX - this._depthChartDimensions.x;
            this._infoXOffset !== i && (this._infoXOffset = this._mouseX - this._depthChartDimensions.x, this._updateInfo());
          }
        }, {
          key: "marketPrice",
          get: function get() {
            return this._marketPrice;
          },
          set: function set(t) {
            this._marketPrice = t, this._draw(!0);
          }
        }]), e;
      }(l.default);
    e.default = v, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = function t(e, i, n) {
        null === e && (e = Function.prototype);
        var o = Object.getOwnPropertyDescriptor(e, i);
        if (void 0 === o) {
          var r = Object.getPrototypeOf(e);
          return null === r ? void 0 : t(r, i, n);
        }
        if ("value" in o) return o.value;
        var a = o.get;
        if (void 0 !== a) return a.call(n);
      },
      u = i(22),
      l = n(u),
      _ = i(0),
      c = n(_),
      d = function (t) {
        function e() {
          o(this, e);
          var t = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return t._uri = c.default.configuration.alphapoint_api.uri, t._instrumentId = c.default.configuration.instrument_id, t._orderBookDepthCount = c.default.configuration.defaults.order_book_depth_count, t._interval = c.default.configuration.defaults.history_interval, t._marketPrice = 0, t;
        }
        return a(e, t), s(e, [{
          key: "connect",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "connect", this).call(this, this._uri);
          }
        }, {
          key: "send",
          value: function value(t) {
            t = JSON.stringify(t), h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "send", this).call(this, t);
          }
        }, {
          key: "disconnect",
          value: function value() {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "disconnect", this).call(this);
          }
        }, {
          key: "onMessage",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "onMessage", this).call(this, t);
            var i = void 0;
            try {
              i = JSON.parse(t.data), "SubscribeTicker" === i.n ? this._onPriceVolumeHistoryLoad(JSON.parse(i.o)) : "SubscribeLevel1" === i.n || "Level1UpdateEvent" === i.n ? this._onMarketPriceLoad(JSON.parse(i.o)) : "SubscribeLevel2" === i.n ? this._onOrderBookDataLoad(JSON.parse(i.o)) : "Level2UpdateEvent" === i.n && this._onOrderBookDataUpdate(JSON.parse(i.o));
            } catch (t) {
              return void console.log(t);
            }
          }
        }, {
          key: "onOpen",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "onOpen", this).call(this, t), this.subscribeToPriceVolumeHistory(), this.subscribeToOrderBookDepth();
          }
        }, {
          key: "onError",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "onError", this).call(this, t);
          }
        }, {
          key: "onClose",
          value: function value(t) {
            h(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "onClose", this).call(this, t);
          }
        }, {
          key: "subscribeToPriceVolumeHistory",
          value: function value() {
            var t = {
              m: 0,
              i: 6,
              n: "SubscribeTicker",
              o: '{"OMSId":1,"InstrumentId":' + this._instrumentId + ',"Interval":' + this._interval + ',"IncludeLastCount":1000}'
            };
            this.send(t);
          }
        }, {
          key: "unsubscribeFromPriceVolumeHistory",
          value: function value() {
            var t = {
              m: 0,
              i: 8,
              n: "UnsubscribeTicker",
              o: '{"OMSId":1,"InstrumentId":' + this._instrumentId + "}"
            };
            this.send(t);
          }
        }, {
          key: "subscribeToOrderBookDepth",
          value: function value() {
            var t = {
              m: 0,
              i: 6,
              n: "SubscribeLevel2",
              o: '{"OMSId":1,"InstrumentId":' + this._instrumentId + ',"Depth":' + this._orderBookDepthCount + "}"
            };
            this.send(t);
          }
        }, {
          key: "unsubscribeFromOrderBookDepth",
          value: function value() {
            var t = {
              m: 0,
              i: 8,
              n: "UnubscribeLevel2",
              o: '{"OMSId":1,"InstrumentId":' + this._instrumentId + "}"
            };
            this.send(t);
          }
        }, {
          key: "_onMarketPriceLoad",
          value: function value(t) {
            this._marketPrice !== t && (this._marketPrice = t, this.dispatchEvent("marketPriceDataUpdate", t));
          }
        }, {
          key: "_onPriceVolumeHistoryLoad",
          value: function value(t) {
            var e = [];
            t.forEach(function (t) {
              e.push([parseInt(t[0], 10) / 1e3 | 0, parseFloat(t[3]), parseFloat(t[4]), parseFloat(t[1]), parseFloat(t[2]), parseFloat(t[5])]);
            }), this.dispatchEvent("historyDataLoad", e);
          }
        }, {
          key: "_onOrderBookDataLoad",
          value: function value(t) {
            var e = this,
              i = {
                asks: [],
                bids: []
              };
            t.forEach(function (t) {
              1 === t[9] ? i.asks.push([t[6], t[5]]) : 0 === t[9] && i.bids.push([t[6], t[5]]), e._onMarketPriceLoad(t[4]);
            }), this.dispatchEvent("orderBookDataLoad", i);
          }
        }, {
          key: "_onOrderBookDataUpdate",
          value: function value(t) {
            var e = this;
            t.forEach(function (t) {
              1 === t[9] ? e.dispatchEvent("orderBookDataUpdate", "ask", t[6], t[5]) : 0 === t[9] && e.dispatchEvent("orderBookDataUpdate", "bid", t[6], t[5]), e._onMarketPriceLoad(t[4]);
            });
          }
        }, {
          key: "interval",
          get: function get() {
            return this._interval;
          },
          set: function set(t) {
            var e = this;
            this._interval !== t && (this._interval = t, this.unsubscribeFromPriceVolumeHistory(), setTimeout(function () {
              return e.subscribeToPriceVolumeHistory();
            }, 250));
          }
        }]), e;
      }(l.default);
    e.default = d, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function o(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function r(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var a = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      s = i(1),
      h = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(s),
      u = function (t) {
        function e() {
          n(this, e);
          var t = o(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return t._socket = null, t._uri = null, t;
        }
        return r(e, t), a(e, [{
          key: "connect",
          value: function value(t) {
            var e = this;
            this._uri = t, this._socket = new WebSocket(this._uri), this._socket.onopen = function (t) {
              e.onOpen(t);
            }, this._socket.onmessage = function (t) {
              e.onMessage(t);
            }, this._socket.onerror = function (t) {
              e.onError(t);
            }, this._socket.onclose = function (t) {
              e.onClose(t);
            };
          }
        }, {
          key: "send",
          value: function value(t) {
            this._socket.send(t);
          }
        }, {
          key: "disconnect",
          value: function value() {
            this._socket.onopen = null, this._socket.onmessage = null, this._socket.onerror = null, this._socket.onclose = null, this._socket.close();
          }
        }, {
          key: "onMessage",
          value: function value(t) {}
        }, {
          key: "onOpen",
          value: function value(t) {}
        }, {
          key: "onError",
          value: function value(t) {}
        }, {
          key: "onClose",
          value: function value(t) {}
        }, {
          key: "connected",
          get: function get() {
            return !(!this._socket || 1 !== this._socket.readyState);
          }
        }, {
          key: "bufferedAmount",
          get: function get() {
            return this._socket ? this._socket.bufferedAmount : 0;
          }
        }]), e;
      }(h.default);
    e.default = u, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = i(0),
      u = n(h),
      l = i(1),
      _ = n(l),
      c = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return n.initialChartData = t, n._changeTickersInterval = i, n._interval = u.default.configuration.defaults.history_interval, n;
        }
        return a(e, t), s(e, [{
          key: "connect",
          value: function value() {
            this.UpdateLevel2Data(this.initialChartData.level2), this.UpdateTickersData(this.initialChartData.tickers.tickers), this.OnLoadingStateChange(this.initialChartData.tickers.fetching), this.UpdateMarketPrice(this.initialChartData.marketPrice);
          }
        }, {
          key: "disconnect",
          value: function value() {}
        }, {
          key: "UpdateLevel2Data",
          value: function value(t) {
            var e = {};
            e.asks = t.sell.map(function (t) {
              return [t.Price, t.NumberOfOrders];
            }), e.bids = t.buy.map(function (t) {
              return [t.Price, t.NumberOfOrders];
            }), this.dispatchEvent("orderBookDataLoad", e);
          }
        }, {
          key: "UpdateTickersData",
          value: function value(t) {
            var e = [];
            t.forEach(function (t) {
              e.push([parseInt(t[0], 10) / 1e3 | 0, parseFloat(t[3]), parseFloat(t[4]), parseFloat(t[1]), parseFloat(t[2]), parseFloat(t[5])]);
            }), this.dispatchEvent("historyDataLoad", e);
          }
        }, {
          key: "OnLoadingStateChange",
          value: function value(t) {
            this.dispatchEvent("loadingStateChanged", t);
          }
        }, {
          key: "UpdateMarketPrice",
          value: function value(t) {
            this.dispatchEvent("marketPriceDataUpdate", t);
          }
        }, {
          key: "interval",
          get: function get() {
            return this._interval;
          },
          set: function set(t) {
            this._interval !== t && (this._interval = t, this._changeTickersInterval(this._interval));
          }
        }]), e;
      }(_.default);
    e.default = c, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = i(0),
      u = n(h),
      l = i(1),
      _ = n(l),
      c = i(25),
      d = n(c),
      f = function f(t) {
        return t.tickers.fetching;
      },
      p = function p(t) {
        return t.tickers.tickers;
      },
      g = function g(t) {
        return t.level2;
      },
      m = function m(t) {
        var e = t.instrument.selectedInstrumentId;
        return e && t.level1[e] ? t.level1[e].LastTradedPx : 0;
      },
      v = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return n._store = t, n._changeTickersInterval = i, n._interval = u.default.configuration.defaults.history_interval, n._marketPrice = 0, n;
        }
        return a(e, t), s(e, [{
          key: "connect",
          value: function value() {
            this.subscribeToPriceVolumeHistory(), this.subscribeToOrderBookDepth(), this.subscribeToMarketPrice(), this.subscribeToLoadingState();
          }
        }, {
          key: "disconnect",
          value: function value() {
            this.unsubscribePriceVolume(), this.unsubscribePriceVolume = null, this.unsubscribeOrderBook(), this.unsubscribeOrderBook = null, this.unsubscribeMarketPrice(), this.unsubscribeMarketPrice = null, this.unsubscribeToLoadingState(), this.unsubscribeToLoadingState = null;
          }
        }, {
          key: "subscribeToPriceVolumeHistory",
          value: function value() {
            var t = this;
            this.unsubscribePriceVolume = (0, d.default)(this._store, p, function (e, i) {
              t._onPriceVolumeHistoryLoad(e);
            });
          }
        }, {
          key: "subscribeToLoadingState",
          value: function value() {
            var t = this;
            this.unsubscribeToLoadingState = (0, d.default)(this._store, f, function (e, i) {
              t._onLoadingStateChanged(e);
            });
          }
        }, {
          key: "subscribeToOrderBookDepth",
          value: function value() {
            var t = this;
            this.unsubscribeOrderBook = (0, d.default)(this._store, g, function (e, i) {
              t._onOrderBookDataLoad(e);
            });
          }
        }, {
          key: "subscribeToMarketPrice",
          value: function value() {
            var t = this;
            this.unsubscribeMarketPrice = (0, d.default)(this._store, m, function (e, i) {
              t._onMarketPriceLoad(e);
            });
          }
        }, {
          key: "_onPriceVolumeHistoryLoad",
          value: function value(t) {
            var e = [];
            t.forEach(function (t) {
              e.push([parseInt(t[0], 10) / 1e3 | 0, parseFloat(t[3]), parseFloat(t[4]), parseFloat(t[1]), parseFloat(t[2]), parseFloat(t[5])]);
            }), this.dispatchEvent("historyDataLoad", e);
          }
        }, {
          key: "_onOrderBookDataLoad",
          value: function value(t) {
            var e = {};
            e.asks = t.sell.map(function (t) {
              return [t.Price, t.NumberOfOrders];
            }), e.bids = t.buy.map(function (t) {
              return [t.Price, t.NumberOfOrders];
            }), this.dispatchEvent("orderBookDataLoad", e);
          }
        }, {
          key: "_onMarketPriceLoad",
          value: function value(t) {
            this._marketPrice !== t && (this._marketPrice = t, this.dispatchEvent("marketPriceDataUpdate", t));
          }
        }, {
          key: "_onLoadingStateChanged",
          value: function value(t) {
            this.dispatchEvent("loadingStateChanged", t);
          }
        }, {
          key: "interval",
          get: function get() {
            return this._interval;
          },
          set: function set(t) {
            this._interval !== t && (this._interval = t, this._changeTickersInterval(this._interval));
          }
        }]), e;
      }(_.default);
    e.default = v, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t, e) {
      return t === e;
    }
    function o(t, e, i) {
      var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : n,
        r = e(t.getState());
      return i(r), t.subscribe(function () {
        var n = e(t.getState());
        if (!o(r, n)) {
          var a = r;
          r = n, i(n, a);
        }
      });
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = o, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    function n(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function r(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }
    function a(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      }(),
      h = i(0),
      u = n(h),
      l = i(1),
      _ = n(l),
      c = function (t) {
        function e(t, i) {
          o(this, e);
          var n = r(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
          return n.subject = t, n._changeTickersInterval = i, n._interval = u.default.configuration.defaults.history_interval, n.level2 = {}, n.tickers = {}, n.fetching = !0, n.marketPrice = 0, n;
        }
        return a(e, t), s(e, [{
          key: "connect",
          value: function value() {
            var t = this;
            this.subject.subscribe(function (e) {
              t.level2 !== e.level2 && (t.level2 = e.level2, t.UpdateLevel2Data(e.level2)), t.tickers !== e.tickers.tickers && (t.tickers = e.tickers.tickers, t.UpdateTickersData(e.tickers.tickers)), t.fetching !== e.tickers.fetching && (t.fetching = e.tickers.fetching, t.OnLoadingStateChange(e.tickers.fetching)), t.marketPrice !== e.marketPrice && t.UpdateMarketPrice(e.marketPrice);
            });
          }
        }, {
          key: "disconnect",
          value: function value() {
            this.subject.unsubscribe();
          }
        }, {
          key: "UpdateLevel2Data",
          value: function value(t) {
            var e = {};
            e.asks = t.sell.map(function (t) {
              return [t.Price, t.NumberOfOrders];
            }), e.bids = t.buy.map(function (t) {
              return [t.Price, t.NumberOfOrders];
            }), this.dispatchEvent("orderBookDataLoad", e);
          }
        }, {
          key: "UpdateTickersData",
          value: function value(t) {
            var e = [];
            t.forEach(function (t) {
              e.push([parseInt(t[0], 10) / 1e3 | 0, parseFloat(t[3]), parseFloat(t[4]), parseFloat(t[1]), parseFloat(t[2]), parseFloat(t[5])]);
            }), this.dispatchEvent("historyDataLoad", e);
          }
        }, {
          key: "OnLoadingStateChange",
          value: function value(t) {
            this.dispatchEvent("loadingStateChanged", t);
          }
        }, {
          key: "UpdateMarketPrice",
          value: function value(t) {
            this.marketPrice = t, this.dispatchEvent("marketPriceDataUpdate", t);
          }
        }, {
          key: "interval",
          get: function get() {
            return this._interval;
          },
          set: function set(t) {
            this._interval !== t && (this._interval = t, this._changeTickersInterval(this._interval));
          }
        }]), e;
      }(_.default);
    e.default = c, t.exports = e.default;
  }, function (t, e, i) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    e.DefaultConfig = {
      instrument_id: 1,
      max_fps: 60,
      snap_mouse_x: !0,
      snap_mouse_y: !1,
      mouse_move_throttle_rate: 33,
      mouse_wheel_throttle_rate: 50,
      currency_character: "฿",
      locale: "en-US",
      loading_text: "loading",
      time_intervals: [{
        label: "5m",
        seconds: 300
      }, {
        label: "15m",
        seconds: 900
      }, {
        label: "30m",
        seconds: 1800
      }, {
        label: "1h",
        seconds: 3600
      }, {
        label: "2h",
        seconds: 7200
      }, {
        label: "4h",
        seconds: 14400
      }, {
        label: "1d",
        seconds: 86400
      }],
      defaults: {
        font_size: 12,
        font_face: "sans-serif",
        history_item_width: 20,
        history_item_margin: 0,
        history_interval: 86400,
        draw_simple_moving_average: !0,
        draw_exponential_moving_average: !0,
        draw_bollinger_bands: !1,
        chart_type: "candlestick",
        order_book_depth_count: 20
      },
      history_data: {
        simple_moving_average_window: 20,
        exponential_moving_average_window: 20,
        bollinger_standard_deviation_offset: 2,
        convergence_divergence_short_window: 12,
        convergence_divergence_long_window: 26,
        convergence_divergence_signal_window: 9
      },
      price_history: {
        font_size: 12,
        font_face: "sans-serif",
        border_primary_color: "#3f4b6d",
        border_secondary_color: "#242a3b",
        background_color: "#1f2531",
        bullish_color: "rgba(63, 204, 124, 1)",
        bearish_color: "rgba(255, 71, 71, 1)",
        price_line_color: "rgba(83, 175, 224, 1)",
        sma_line_color: "rgba(128, 142, 166, 1)",
        ema_line_color: "rgba(209, 187, 111, 1)",
        bollinger_band_upper_line_color: "rgba(100, 200, 100, 1)",
        bollinger_band_lower_line_color: "rgba(200, 100, 100, 1)",
        market_price_line_color: "rgba(49, 149, 96, 1)",
        market_price_label_color: "rgba(255, 255, 255, 1)",
        market_price_background_color: "rgba(49, 149, 96, .5)",
        x_label_color: "#76809b",
        y_label_color: "#76809b",
        info_height: 30,
        info_precision: 5,
        y_label_width: 60,
        y_label_precision: 5,
        x_label_height: 30,
        x_label_precision: 5,
        info_labels: ["Price", "Open", "Close", "High", "Low", "Volume"],
        use_gradient: !1,
        first_gradient_color: "red",
        second_gradient_color: "blue",
        use_grid_lines: !1,
        grid_lines_dashed: !0,
        grid_lines_color: "white"
      },
      volume_history: {
        font_size: 12,
        font_face: "sans-serif",
        border_primary_color: "#3f4b6d",
        border_secondary_color: "#242a3b",
        background_color: "#1f2531",
        bullish_color: "rgba(63, 204, 124, 1)",
        bearish_color: "rgba(255, 71, 71, 1)",
        x_label_color: "#76809b",
        y_label_color: "#76809b",
        y_label_width: 60,
        y_label_precision: 0,
        x_label_height: 0,
        x_label_precision: 0
      },
      macd_history: {
        font_size: 12,
        font_face: "sans-serif",
        border_primary_color: "#3f4b6d",
        border_secondary_color: "#242a3b",
        background_color: "#1f2531",
        zero_line_color: "rgba(36, 42, 59, 1)",
        indicator_line_color: "rgba(71, 129, 255, 1)",
        signal_line_color: "rgba(255, 71, 71, 1)",
        histogram_positive_color: "rgba(63, 204, 124, .25)",
        histogram_negative_color: "rgba(255, 71, 71, .25)",
        x_label_color: "#76809b",
        y_label_color: "#76809b",
        y_label_width: 60,
        y_label_precision: 0,
        x_label_height: 0,
        x_label_precision: 0
      },
      range_selector: {
        font_size: 12,
        font_face: "sans-serif",
        border_primary_color: "#3f4b6d",
        border_secondary_color: "#242a3b",
        background_color: "#1f2531",
        market_price_line_color: "rgba(232, 232, 92, 1)",
        market_price_label_color: "rgba(232, 232, 92, 1)",
        price_line_color: "rgba(83, 175, 224, 1)",
        range_selection_color: "rgba(255, 255, 255, .2)",
        x_label_color: "#76809b",
        y_label_color: "#76809b",
        y_label_width: 0,
        y_label_precision: 0,
        x_label_height: 22,
        x_label_precision: 0
      },
      order_book_depth: {
        font_size: 12,
        font_face: "sans-serif",
        border_primary_color: "#3f4b6d",
        border_secondary_color: "#242a3b",
        background_color: "#1f2531",
        ask_line_color: "rgba(255, 71, 71, 1)",
        ask_fill_color: "rgba(255, 71, 71, .5)",
        bid_line_color: "rgba(63, 204, 124, 1)",
        bid_fill_color: "rgba(63, 204, 124, .5)",
        market_price_color: "#6f7faa",
        x_label_color: "#76809b",
        y_label_color: "#76809b",
        info_height: 30,
        info_precision: 2,
        y_label_width: 60,
        y_label_precision: 2,
        x_label_height: 22,
        x_label_precision: 5,
        update_interval: 1e3,
        depth: 10
      },
      number_suffixes: ["", "k", "M", "B", "T", "Q"],
      date_format_days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      date_format_months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      alphapoint_api: {
        uri: "wss://api_demo2.alphapoint.com/WSGateway/"
      }
    };
  }]);
});